export default {
  view: "View",
  compact: "Compact",
  full: "Full",
  more: "Details",
  cancel: "取消",
  close: "关",
  confirm: "确认操作",
  yes: "是",
  no: "否",
  save: "保存",
  save_and_send: "保存并发送",
  save_and_sign: "保存并签署",
  delete: "删除",
  back: "返回",
  edit: "编辑",
  select: "通过参数选择",
  deselect: "隐藏",
  ok: "OK",
  add: "添加",
  readmore: "显示更多",
  unreadmore: "隐藏",
  collapse: "最小",
  expand: "最大",
  wait: "下载中，请勿关闭页面",
  tnved_code: "",
  tnved_name: "HS编码名称",
  error: "保存出错，请重试",
  "errors-at-tab": "文件夹中存在错误",
  "errors-dialog-title": "文件中存在错误",
  "errors-dialog":
    "文件中存在错误，无法保存数据。请纠正如下标记的文件夹中的错误，并尝试再次保存数据。",
  message: {
    "invite-ok": "邀请发送成功",
    "registration-successfull": "录入成功",
    "login-successfull": "授权成功",
    "contract-created": "合同录入成功",
    "contract-not-created": "合同未完成录入",
    "invoice-created": "发票录入成功",
    "invoice-not-created": "发票未完成录入",
    "packaging-created": "箱单录入成功",
    "packaging-not-created": "箱单未完成录入",
    "cmr-created": "CMR录入成功",
    "cmr-not-created": "CMR未完成录入",
    "fm1-created": "FM1录入成功",
    "fm1-not-created": "FM1未完成录入",
    "epi-created": "EPD录入成功",
    "epi-not-created": "EPD未完成录入",
    "awb-created": "AWB录入成功",
    "awb-not-created": "AWB未完成录入",
    "ktg-ok": "铁路运单录入成功",
    "ktg-nok": "铁路运单未完成录入",
    "decline_delivery_offer-ok": "报价被拒绝",
    "decline_delivery_offer-nok": "请求未完成录入",
    "decline_broker_offer-ok": "报价被拒绝",
    "decline_broker_offer-nok": "请求未完成录入",
    "create-delivery_offer-nok": "报价未完成录入",
    "select-delivery_offer-nok": "请求未完成录入",
    "delivery_offer-ok": "报价录入成功",
    "create-delivery_offer-ok": "录入成功",
    "select-delivery_offer-ok": "请求录入成功",
    "create-broker_offer-ok": "录入成功",
    "create-broker_offer-nok": "报价未完成录入",
    "broker_offer-ok": "报价接受",
    "broker_offer-nok": "请求未完成录入",
    "select-broker_offer-ok": "请求录入成功",
    "select-broker_offer-nok": "请求未完成录入",
    astana_1_ok: "XML文件录入成功",
    astana_1_nok: "XML文件未完成录入",
    d_selector_ok: "XLSX文件录入成功",
    d_selector_nok: "XLSX文件未完成录入",
    wsdl_astana_1_ok: "请求发送成功",
    wsdl_astana_1_nok: "请求未完成录入",
    ktzh_sftp_ok: "请求发送成功",
    ktzh_sftp_nok: "请求未完成录入",
    contract_signed: "合同签订成功",
    contract_not_signed: "未签订，请重试",
    document_signature_is_wrong: "签署错误，文件已更改或仍未签署",
    document_signature_is_ok: "签署正确，纸质文本创建完成",
    document_signed: "签署正确，纸质文本创建完成",
    document_not_signed: "文件签署成功",
    success: "操作完成成功",
    no_success: "操作失败",
    "rwb-created": "铁路运单保存成功",
    "rwb-not-created": "铁路运单保存失败",
    "insurance-created": "保单保存成功",
    "insurance-not-created": "保单保存失败",
    signature_bin_is_not_found: "您签名中无BIN，请使用不同的签名",
    signature_bin_is_not_valid: "您签名中的BIN不匹配，请使用不同的签名",
    signature_no_contragent: "您不能再合同中签字，未选中合同",
    "offer-created": "",
    "offer-not-created": "",
    "offer-deleted": "",
    "offer-not-deleted": "",
  },
  deals: {
    no: "未注册的交易",
  },
  archive: {
    no: "交易档案为空",
  },
  aml: {
    aka: "其它标题",
    fields: "领域",
    media: "媒体",
    keywords: "关键字",
    field_name: "标题",
    field_source: "来源",
    field_value: "价值",
    noresults: "没有结果",
  },
  notifications: {
    empty: "没有通知",
    showall: "显示所有通知",
    notifications_title: "通知",
    view_title: "查看通知",
    type_1_title: "申请编号为{{对象ID}}的询价已接收",
    type_1_text:
      "尊敬的{{组织名}}，关于您的申请，您已收到来自{{创建人}} 的报价",
    type_2_title: "申请编号为{{对象ID}}的方案的准许通知",
    type_2_text: "尊敬的{{组织名}}，您已接收到来自{{创建人}} 的请求",
    type_3_title: "申请号{{对象ID}}的合同批准通知",
    type_3_text:
      "尊敬的{{组织名}}，关于您的申请，您已收到来自{{创建人}} 的合同批准",
    type_4_title: "交易参与通知",
    type_4_text:
      "尊敬的{{组织名}}，关于您参与交易的申请，您已收到来自{{创建人}}的接受意见",
    type_5_title: "拒绝参与交易通知",
    type_5_text:
      "尊敬的{{组织名}}，关于您参与交易的申请，您已收到{{创建人}}的拒绝意见",
    type_6_title: "关于申请编号为{{对象}}的货物运输邀请",
    type_6_text: "尊敬的{{组织名}}，您已接收到一份来自{{创建人}}的货物运输报价",
    type_7_title: "接受编号为{}的货物运输申请",
    type_7_text: "尊敬的{{组织名}}，您关于货物运输的申请被{{创建人}}接受",
    type_8_title: "关于申请编号为{{对象}}的货物运输被拒绝",
    type_8_text: "尊敬的{{组织名}}，您关于货物运输的申请被{{创建人}}拒绝",
    type_9_title: "申请编号为{{对象}}的承运人选择",
    type_9_text: "尊敬的{{组织名}}，贵公司被{{创建人}}选择执行此货物交付",
    type_10_title: "关于申请号为{{对象}}的报关行服务报价",
    type_10_text: "尊敬的{{组织名}}，您已收到来自{{创建人}}的代理清关服务报价",
    type_11_title: "申请编号为{{对象}}的报关行选择",
    type_11_text: "尊敬的{{组织名}}，您公司被{{创建人}}选择执行清关代理服务",
    type_12_title: "申请编号为{{对象}}的代理清关服务已接受",
    type_12_text: "尊敬的{{组织名}}，您的代理清关服务申请被{{创建人}}接受",
    type_13_title: "申请编号为{{对象}}的代理清关服务被拒绝",
    type_13_text: "尊敬的{{组织名}}，您代理清关服务申请被{{创建人}}拒绝",
    type_14_title: "申请编号为{{对象}}的代理清关方选择",
    type_14_text: "尊敬的{{组织名}}，您公司被{{创建人}}选择执行清关代理服务",
    type_15_title: "签订一个交易合同",
    type_15_text: "尊敬的{{组织名}}，您的申请已被{{创建人}}签订，链接至申请",
    type_26_title: "在申请编号为{{对象}}上回复",
    type_26_text:
      "尊敬的{{组织名}}，您收到了一条来自{{创建人}}关于您申请的回复",
    contragent: "交易方",
    offer: "订单",
    courieroffer: "货物运输订单",
    contract: "合同",
    CreatorName: "来自",
    OrgName: "到",
    Title: "主题",
    CreationDate: "日期",
    perPage: "被展示",
  },
  menu: {
    customers: "对客户",
    about: "关于我们",
    partners: "对合作方",
    events: "事件",
    project: "关于项目",
    board: "管理层",
    services: "服务",
    contacts: "合同",
    signin: "登录",
    register: "录入",
    find_partner: "合作方搜索",
    "my-orders": "我的合同",
    orders: "合同",
    deals: "交易档案是空的",
    archive: "归档",
    logout: "退出",
    account: "我的账户",
  },
  account: {
    bin: "公司ID",
    "company-country": "注册国家",
    iin: "个人ID",
    dob: "生日",
    gender: "性别",
    male: "男",
    female: "女",
    "user-section": "用户",
    "company-section": "公司",
    edit_profile: "编辑账户",
    change_password: "修改密码",
    contracts: "我的合同",
    offers: "我的申请",
    residency: "住所",
    phone: "电话",
    email: "邮箱",
    position: "职位",
    address: "地址",
    old_password: "当前密码",
    old_password_wrong: "当前密码错误",
    insecure_new_password: "密码必须至少由一个数字和一个符号组成",
    short_new_password: "密码必须由8个字符组成",
    new_password: "新的密码",
    confirm_password: "确认密码",
    fill_all_fields: "完成表格所有内容",
    passwords_not_equal: "新的密码和确认的密码不一致",
    accounts_of_company: "公司银行账户",
    documents_of_company: "文件",
    addresses_of_company: "公司地址",
    founders_of_company: "公司股东",
    socials: "社交网络",
    org_name: "公司名称",
    org_custom_code: "公司海关编码",
    org_type: "公司类型",
    company_website: "网站",
    country: "注册国家",
    bank: "银行",
    account: "银行账户",
    currency: "账户币种",
    is_open: "有效的",
    add_bank: "添加银行",
    save_bank: "保存银行",
    org_founders_person_name: "股东全称",
    org_founders_company: "股东公司名称",
    org_founders_share: "股权比例",
    org_founders_country: "住址",
    add_founder: "添加股东",
    save_founder: "保存股东",
    jur_address: "注册地址",
    post_address: "通信地址",
    fact_address: "实际地址",
    post_addr_country: "国家",
    index: "邮编",
    region: "区域",
    district: "地区",
    town: "城市",
    city: "所在地",
    street: "街道",
    house: "楼栋号",
    room: "办公室号",
    number: "邮箱或电话",
    org_oked: "企业注册号",
    company_contacts: "联系人",
    org_reg_date: "最初注册时间",
    org_reregdate: "最新公司信息变更",
    company_status: "公司状态",
    company_filials: "分公司（如有）",
    company_ceo: "CEO 信息",
    company_ceo_date: "CEO 任命日期",
    organization_networks: "社会网络",
    org_is_broker: "报关行",
    org_is_carrier: "承运人",
    org_is_bank: "银行",
    kpved: "经营范围",
    address_clone: "复制公司注册地址",
    document_number: "文件编号",
    document_serial: "文件序列",
    document_date: "文件日期",
    document_issued_by: "签署人",
    document_active: "有效的",
    document_exp_date: "文件有效期",
    add_document: "添加文件",
    update_document: "更新文件",
    signatures: "签署",
    cert_installed: "签字证书安装",
    cert_start_date: "证书生效日期",
    end_start_date: "证书有效期",
    add_new_cert: "添加新的证书",
    change_signature: "您将改变您的电子签名，旧的签名将失效，是否确定？",
    signature_is_not_valid_yet: "“签名证书未生效，无法安装”，",
    signature_is_already_not_valid: "“签名证书已过期，无法安装”，",
    pa_oferta: "合同签署方案",
    insurance_requests: "投保需求",
    ceo_name: "头目全名",
    status: "申请状态",
    statute: "章节",
    registration_certificate: "国家注册证书",
    signature_right_certificate: "合理签署订单/文件的头目",
    ceo_passport: "头目的身份卡/密码",
    insurance_request_certificate: "保单",
    insurance_request_insurer_message: "拒绝原因消息",
    insurance_request_status_returned: "由保险公司退回修改",
    insurance_request_status_new: "新的",
    insurance_request_status_approved: "已通过的",
    insurance_request_status_: "新的",
    add_insurance_requests: "添加投保申请",
    contract: "合同签署方案",
    org_is_insurer: "该组织是保险公司",
  },
  home_slider: {
    header: "跨境电子贸易平台",
    subheader: "“集成中国、哈萨克斯坦、俄罗斯、欧盟及周边地区”，",
  },
  home_adv: {
    base_title: "基础",
    base_text: "建立在经验证的实施方案之上",
    standards_title: "标准",
    standards_text: "“应用世界级标准在全球推行”，",
    workflow_tilte: "工作流",
    workflow_text: "“完整的跨境电子文件整合”，",
    integration_title: "集成",
    integration_text: "“外贸一体化、国家一体化、金融一体化”，",
    scale_title: "“可扩展性”,",
    scale_text: "“共同的州际运输和清算系统”，",
  },
  title: {
    news: "最后事件",
  },
  reg_form: {
    sure_cancel: "",
    kompra: "从stat.gov.kz下载",
    title: "登记表",
    title_wf: "登记",
    customer_data: "客户数据",
    customer_id: "输入个人ID",
    customer_id_not_kz: "ID",
    customer_last_name: "输入姓氏",
    customer_first_name: "输入名字",
    customer_middlename: "输入中间名（如有）",
    customer_email: "输入邮箱地址",
    customer_password: "输入初始密码",
    customer_password_placeholder:
      "至少8个字符。必须由数字、字母和标点符号组成",
    customer_birthdate: "出生日期",
    customer_address: "居住地址",
    customer_position: "职位",
    customer_phone: "电话",
    customer_gender: "性别",
    customer_male: "男",
    customer_female: "女",
    company_data: "公司信息",
    company_id: "USCC",
    company_id_not_kz: "公司代码",
    company_title: "输入公司职位",
    company_regdate: "初始注册日期",
    company_status: "公司状态",
    company_reregdate: "最近工商状态",
    company_oked: "营业范围",
    company_oked_code: "营业范围代码",
    secondary_company_oked: "补充经营业务代码",
    secondary_company_oked_code: "补充经营业务",
    company_contacts: "联系人（如有）",
    company_region: "地区",
    company_main_sphere: "主要营业范围",
    company_additional_sphere: "营业补充范围（如有）",
    company_filials: "分支机构（如有）",
    company_ceo: "CEO信息",
    company_ceo_date: "CEO任职日期",
    company_founder: "股东信息",
    company_number_of_founders: "股东人数",
    company_social_networks: "社交网络",
    company_website: "网站",
    company_address: "公司注册地址",
    company_accept: "接受公有协议",
    submit_button: "提交申请",
  },
  login_form: {
    title_wf: "登录我的账号",
    submit_button: "登录",
    password: "密码",
    email: "电子邮箱",
    ecp_login: "用电子签名登录",
    ecp_NONE: "选择类型",
    ecp_PKCS12: "我的电脑",
    ecp_AKKaztokenStore: "哈萨克斯坦安全网络渠道",
    ecp_AKKZIDCardStore: "我的身份证信息卡",
    ecp_type: "电子密钥存储类型",
    ecp_login: "用EDS登录",
    ecp_NONE: "选择类型",
    ecp_PKCS12: "您的电脑",
    ecp_AKKaztokenStore: "哈萨克斯坦安全网络渠道",
    ecp_AKKZIDCardStore: "个人识别",
    ecp_type: "关键存储类型",
    forgot_password: "忘记您的密码？",
    forgot_password_button: "创建新的密码",
    forgot_password_description: "新的密码链接将发至邮箱",
    forgot_email_sent: "检查您的邮件，已发送带有重置密码链接的邮件",
    forgot_email_not_sent: "找不到该用户或发生了错误",
    reset_password_button: "更改密码",
    reset_password: "设置新密码",
    reset_password_description:
      "为您的帐户设置新密码(输入您的电子邮件和新密码)",

    reset_password_success_description:
      "The new password is successfully saved",
    reset_password_success: "Password changed",
    time_to_logout_description: "Session expired. You need to login again.",
    time_to_logout_title: "Session expired",
  },
  find_partner: {
    common_help_item_title: "解释",
    common_help_item_1: "注册员工人数与业务规模相符",
    common_help_item_2: "重要的不是注册资本，而是实缴资本",
    common_help_item_3: "公司的资本与业务规模和活动领域相符（中国法律要求）",
    common_help_item_4: "空表、无内容的帮助条目和缺失的条目表明所审查公司的活动与这些条目无关",
    common_help_item_5: "由于字段数量较多，有些表格会被拆分到下一行",
    common_help_item_6: "“记录变更信息”表包含公司发展的时间顺序（在帮助的扩展版中）",
    
    specific_help_items_title: "某些帮助条目值的解释",
    
    entType_explanation_title: "企业活动性质",
    entType_explanation: "0-大陆企业，1-社会组织，3-香港公司，4-政府机构，5-台湾公司，6-基金会，7-医院，8-海外公司，9-律师事务所，10-学校，11-机构代理",
    
    IXCode_explanation_title: "企业进出口代码",
    IXCode_explanation: "用于在进出口操作期间识别公司。对于任何希望从事国际贸易的公司，这是强制性要求",
    
    permissionInfo_explanation_title: "行政许可",
    permissionInfo_explanation: "行政主体通过根据行政相对方的申请在法律一般禁止的情况下颁发许可或执照的方式，法律授权特定行政相对方从事特定活动或进行特定行为。权利或资格的行政行为。该概念包含三个含义：首先，存在一般法律禁令；其次，行政主体解除对相对方的一般禁令；第三，行政相对方获得从事特定活动或进行特定行为的资格或权利",
    
    exceptions_explanation_title: "异常经营（纳入名录）",
    exceptions_explanation: "根据法律限制或禁止政府采购、项目招标、国有土地转让，取消荣誉称号。信用限制机制将影响银行信贷、合同签订、海关清关、外国公司员工的工作证书获取等"
  },
  errors: {
    required: "必填字段",
    integer: "仅数字",
    alpha: "仅字幕",
    min_length: "最小12个字符",
    max_length: "最大12个字符",
    email: "输入正确的邮箱",
    url: "输入正确的 URL",
    password: "密码必须至少由一个数字和一个符号组成",
  },
  contracts: {
    ktzh_log_type_request: "请求",
    ktzh_log_type_response: "回复",
    ktzh_movement_1: "1 - 国内线路",
    ktzh_movement_2: "2 - 出口",
    ktzh_movement_3: "3 - 出口",
    ktzh_movement_4: "4 - 运输",
    ktzh_movement_5: "5 - 所有线路",
    ktzh_participant_1: "1 - 发送人",
    ktzh_participant_2: "2 - 货运代理",
    ktzh_participant_0: "0 - 接收人",
    paper_copy: "文件副本",
    paper_copy_no_logo: "文件副本",
    paper_copy_proxy_ktzh: "哈萨克斯坦委托书",
    paper_copy_proxy_ktzh_no_logo: "哈萨克斯坦授权书（无标志）",
    paper_copy_invoice: "发票",
    paper_copy_invoice_no_logo: "发票（无标志）",
    paper_copy_cmr: "CMR",
    paper_copy_cmr_no_logo: "CMR（无标志）",
    paper_copy_contract: "合同",
    paper_copy_contract_no_logo: "合同（无标志）",
    upload: "上传",
    customs_organs: "海关当局",
    customs_xml_astana_1: "阿斯塔纳1 XML文件",
    customs_xml_astana_1_title: "下载合同{合同ID}XML文件以上传至ASTANA-1",
    make_xml_file: "创建XML文件",
    customs_xlsx_d_selector: "XLSX D-选择器",
    customs_xlsx_d_selector_title: "为D区TS应用软件下载合同{合同ID}数据",
    make_xlsx_file: "创建XLSX文件",
    customs_wsdl_astana: "阿斯塔纳1的WSDL",
    customs_wsdl_astana_title: "阿斯塔纳1网络服务，合同{合同ID}",
    send_data_to_astana_1: "发送数据至阿斯塔纳1",
    astana_1_answer: "阿斯塔纳1的回复",
    transport_organs: "承运人",
    transport_ktzh: "哈萨克斯坦",
    transport_ktzh_title: "与哈萨克斯坦对合同{合同ID}的数据交换",
    transport_ktzh_make_title: "哈萨克斯坦对合同{合同ID}的数据请求",
    transport_ktzh_view_title: "哈萨克斯坦对合同{合同ID}的请求意见",
    transport_ktzh_view_resp_title: "哈萨克斯坦对合同{合同ID}的回复意见",
    ktzh_log_id: "",
    ktzh_log_type: "请求/回复",
    ktzh_log_date: "日期",
    ktzh_log_file: "文件夹",
    ktzh_log_action: "浏览",
    make_ktzh_request: "数据请求至哈萨克斯坦",
    ktzh_for_date: "按日期",
    ktzh_bin: "公司ID",
    ktzh_movement_type: "信息类型",
    ktzh_participant_type: "用户类型",
    ktzh_expeditor_code: "货运代理代码",
    ktzh_send_request: "向SFTP发送请求",
    ktzh_invoice_un: "唯一ID",
    ktzh_invoice_num: "批次号",
    ktzh_recive_station_code: "起运站代码",
    ktzh_dest_station_code: "目的站代码",
    ktzh_sender_exp_no: "12位电子发货人代码，优先使用发货人出口代码（若有）",
    ktzh_etsng_code: "货物CIS分类代码",
    ktzh_fact_mass: "车厢容量",
    ktzh_payer_code: "付款人SAP代码",
    ktzh_vag_no: "车厢号码",
    ktzh_vag_count: "本批次总车厢数量",
    ktzh_gruz: "货物重量（实际）",
    ktzh_invc_dt: "货物被接收时间",
    ktzh_container_no: "集装箱号",
    ktzh_smgs_type: "洲际运输类型",
    transport_auto: "公路运输",
    transport_avia: "航空运输",
    transport_water: "海上运输",
    governmental_organs: "国家部门",
    governmental_organs_tax: "哈萨克税务部门",
    governmental_organs_certification: "认证部门",
    governmental_organs_fin_monitoring: "反洗钱合规审查部门",
    governmental_organs_customs: "边境管制",
    governmental_organs_make_choise: "选择",
    exim: "出口进口",
    brokers_tab: "清关代理",
    broker: "清关代理",
    choose_broker: "清关代理选择",
    epi_price: "EPD 费用",
    td_price: "TD 费用",
    broker_request_modal_title: "合同**的清关代理服务申请",
    broker_request: "清关代理服务请求",
    select_broker: "选择清关代理",
    epi_price_currency: "汇率",
    td_price_currency: "汇率",
    delivery_term: "交付条款",
    brokers: "清关代理",
    couriers_tab: "运输",
    view: "查看",
    delivery_price: "交付成本",
    delivery_date: "交付时间",
    offer_date: "报价截止日期",
    choose_courier: "承运人选择",
    delivery_request: "交付申请",
    select_courier: "选择承运人",
    delivery_request_modal_title: "合同**的运输报价",
    delivery_request_from: "从",
    delivery_type: "交付方式",
    delivery_type_auto: "公路运输",
    delivery_type_railway: "铁路运输",
    delivery_type_avia: "航空运输",
    delivery_type_sea: "海上运输",
    delivery_type_post: "邮箱",
    from_address: "启运地",
    to_address: "到达地",
    weight: "毛重",
    volume: "容量",
    delivery_price_currency: "汇率",
    date_of_load: "装货日期",
    date_of_delivery: "交付日期",
    packaging: "包装",
    hazard_class: "危险品等级",
    hazard_class0: "非危险品",
    hazard_class1: "第1类:爆炸性物质和物品",
    hazard_class2: "第2类:气体",
    hazard_class3: "第3类:易燃液体",
    hazard_class4: "第4类:易燃固体、自反应物质和固体脱敏炸药",
    hazard_class5: "第5类:氧化性物质",
    hazard_class6: "第6类:有毒及传染性物质",
    hazard_class7: "第7类:放射性物质",
    hazard_class8: "第8类:腐蚀性物质",
    hazard_class9: "第9类:其他危险物质和物品",
    comments: "备注",
    couriers: "承运人",
    couriers_attahments_info: "保存此报价时新附件将被保存",
    courier_name: "标题",
    courier_code: "代码",
    invite: "邀请",
    offer_from: "报价来自于",
    offers_show_declined: "显示被拒绝的报价",
    offer_no_changes: "对无修改待签合同的报价",
    offer_no_changes_message:
      "当发送此报价将自动以您的电子签签署合同。如果发起人接收您的报价，交易将成立",
    submit_ktg: "哈萨克斯坦",
    attachements: "附件",
    add_attachement: "添加附件",
    add_attachement_info: "保存此合同时新附件将被保存",
    "close-contract": "更改将不被保存。是否确定关闭合同？",
    filter_contracts: "筛选合同",
    number: "数量",
    title: "主题",
    amount: "金额",
    date: "日期",
    owner: "货主方",
    contragent: "交易方",
    currency: "汇率",
    new: "创建",
    add_form: "创建合同",
    contract_tab: "合同",
    contragents_tab: "交易方",
    offers_tab: "报价",
    contract_status: "合同状态",
    status_1: "申请",
    status_2: "交易协商",
    status_3: "成交",
    status_4: "无效",
    type: "合同类型",
    case: "合同模板",
    type_buy: "买进",
    type_sell: "卖出",
    case_product: "货物",
    case_service: "服务",
    subject: "主题",
    description: "描述",
    currency: "汇率",
    contract_date: "交付日期",
    contract_amount: "合同金额",
    buyer: "买家",
    seller: "卖家",
    product: "商品",
    payment: "付款",
    courier: "承运人",
    actions: ",",
    product_title: "名称",
    product_sku: "海关编码",
    product_qty: "数量",
    product_units: "计量单位",
    product_unit_price: "价格",
    conditions: "交付条款",
    payment_conditions_code: "付款条款代码",
    payment_conditions: "付款条款",
    place: "目的地",
    term: "运输日期",
    is_public: "公法契约",
    submit_and_sign_button: "保存并签署",
    submit_button: "保存合同",
    add_form: "创建新合同",
    edit_form: "编辑合同",
    current_contracts: "合同",
    products: "商品",
    add_product: "添加商品",
    number_of_items: "物料数量",
    find_partner: "合作方搜索",
    find_param_1: "参数1",
    find_param_2: "参数2",
    find_param_3: "参数3",
    find_param_4: "参数4",
    find_param_5: "参数5",
    find_param_6: "参数6",
    search_other: "在ATTIS外搜索",
    shipping_cost: "交付成本",
    search: "搜索",
    save_search: "保存搜索结果",
    send_notifications: "发送通知",
    saved_searches: "已保存的搜索",
    search_results: "搜索结果",
    contragents_search_id: "申请人编号",
    contragents_search_country: "国家",
    contragents_search_name: "名称",
    contragents_search_contact: "联系方式",
    contragents_search_sphere: "经营业务",
    contragents_search_checked: "已选择",
    contragents_search_email: "电子邮箱",
    attis_contract_deadline: "报价有效期",
    saved_searches_date: "搜索日期",
    saved_searches_number_of_results: "搜索结果数量",
    documents_tab: "文件",
    docs_cat_all: "全部",
    docs_cat_commerce: "商业",
    docs_cat_finance: "财务",
    docs_cat_transport: "运输",
    docs_cat_customs: "海关",
    double_click_to_open: "双击打开",
    add_file: "添加文件",
    browse: "拖拽文件至此处，或在对话中单击选择",
    file_too_big: "文件超过10MB，请重新选择文件",
    file_too_big20: "文件超过20MB，请重新选择文件",
    file_wrong_type:
      "仅支持JPG, PNG, PDF, DOC, XLS, DOCX and XLSX等文件类型，请选择合适的文件后再试",
    offer: "报价",
    products_description: "商品描述",
    offer_status: "状态",
    offer_file: "文件",
    offer_valid_date: "报价有效期",
    offer_changes: "更新",
    single_offer: "查看报价",
    offer_answer: "回复",
    offer_accept: "接受",
    contract_sign: "签署合同",
    offer_decline: "拒绝",
    offer_answer_title: "报价反馈",
    offer_chain_title: "回复记录",
    offer_show_chain_answer: "查看沟通记录",
    offer_hide_chain_answer: "隐藏沟通记录",
    offer_answer_text: "沟通文本",
    offer_answer_send: "发送",
    single_document: "查看文件",
    new_document: "创建文件",
    document_number: "文件号码",
    document_date: "文件日期",
    document_types: "文件类型",
    document_invoice: "发票",

    document_payment: "付款单",
    document_save: "保存",
    document_create: "创建",
    document_file: "文件（最大20MB）",
    invoice_document_number: "发票号码",
    invoice_document_date: "发票日期",
    invoice_document_currency: "发票币种",
    invoice_document_places_quantity: "仓储地数量",
    invoice_document_places_description: "仓储地类型",
    invoice_document_gross_weight: "毛重（kg）",
    invoice_document_net_weight: "净重（kg）",
    invoice_document_gcost: "总金额",
    invoice_document_discount: "折扣金额",
    invoice_document_transport_charges: "运输费用",
    invoice_document_insurance_charges: "保险费用",
    invoice_document_other_charges: "其他费用",
    invoice_document_total_cost: "发票总金额",
    invoice_document_payment_period: "付款日期",
    invoice_document_buyer: "买家",
    invoice_document_seller: "卖家",
    invoice_products: "发票商品信息",
    cmr_products: "商品信息",
    invoice_products_GoodMarking: "生产商编码",
    invoice_products_GoodsCode: "海关编码",
    invoice_products_GoodsDescription: "商品描述",
    invoice_products_GoodsQuantity: "商品数量",
    invoice_products_SupplementaryQualifierName: "供货计量单位",
    invoice_products_GrossWeightQuantity: "商品毛重（kg）",
    invoice_products_NetWeightQuantity: "商品净重（kg）",
    invoice_products_Price: "商品/服务价格",
    invoice_products_Discount: "折扣金额",
    invoice_products_DiscountPercentage: "折扣比例%",
    invoice_products_OriginCountryCode: "原产国代码",
    invoice_products_ServiceCharges: "服务费用",
    invoice_products_TransportCharges: "运输费用",
    invoice_products_OtherCharges: "其他费用",
    document_cancel_message: "确定取消更新吗？",
    company_number: "编号",
    company_name: "名称",
    company_address: "地址",
    company_bank: "银行",
    company_account: "银行账号",
    add_seller: "增加卖家",
    add_buyer: "增加买家",
    offer_new: "增加报价",
    document_cmr: "CMR",
    cmr_products_GoodsMarking: "唛头和数量",
    cmr_products_GoodsQuantity: "地点数量",
    cmr_products_GoodsDescription: "货物名称",
    cmr_products_GoodsNomenclatureCode: "海关编码",
    cmr_products_GrossWeightQuantity: "商品毛重（kg）",
    cmr_products_VolumeQuantity: "商品立方体积",
    cmr_number: "CMR 号码/国际公路货物运输单号码",
    cmr_date: "CMR日期",
    cmr_sender: "发货方",
    cmr_recipient: "地址",
    cmr_courier: "承运人",
    cmr_courier_next: "后程承运人",
    cmr_track: "车辆型号和车牌号",
    cmr_trailer: "车板牌号",
    DeliveryPlace: "目的地",
    DeliveryTermsStringCode_code: "运输条款代码",
    DeliveryTermsStringCode: "运输条款",
    TermsDescription: "备注",
    cmr_g_3: "卸货目的地",
    cmr_g_4: "装货时间和地点",
    cmr_CountryCode: "国家",
    cmr_City: "城市",
    cmr_StreetHouse: "地址",
    cmr_PostalCode: "邮政编码",
    cmr_TakingCargoDate: "装货日期",
    cmr_WarehouseName: "保税或海关仓库",
    add_courier: "增加承运人",
    add_courier_next: "增加后程承运人",
    add_sender: "增加发货人",
    add_recipient: "增加地址",
    document_fm1: "AML F1",

    fm1_tab1: "反洗钱 F1 信息",
    fm1_tab1_short: "信息",
    fm1_main_date: "1.2 反洗钱 F1 日期",
    fm1_main_doc_kind: "1.3 文件类型",
    fm1_main_form_state: "1.4 手续状态",
    fm1_main_reason: "1.5 提交原因",
    fm1_main_doc_kind_1: "新信息",
    fm1_main_doc_kind_2: "已被拒绝的信息修改",
    fm1_main_doc_kind_3: "信息替换请求",
    fm1_main_doc_kind_2_number: "输入信息修改编码",
    fm1_main_doc_kind_3_number: "输入信息数量",
    fm1_main_form_state_1: "完成",
    fm1_main_form_state_2: "继续",
    fm1_main_form_state_3: "暂停",
    fm1_main_form_state_4: "未完成",
    fm1_main_form_state_1_date: "手续/交易付款完成日期",
    fm1_main_form_state_2_date: "手续/交易开始日期",
    fm1_main_form_state_3_date: "手续/交易被反洗钱暂停时间",
    fm1_main_subreason: "选择选项",
    fm1_main_reason_1: "等于或超过最低限额",
    fm1_main_reason_2: "可疑交易",
    fm1_main_reason_sub_1: "无真实经济意义的交易",
    fm1_main_reason_sub_2: "为避免反洗钱合规审查的可疑交易",
    fm1_main_reason_sub_3: "恐怖主义和(或)极端主义的赞助付款",
    fm1_tab2: "对象已提交反洗钱F1信息",
    fm1_tab2_short: "",
    fm1_subj_code: "2.1 反洗钱对象ID",
    fm1_subj_group: "2.2 反洗钱对象",
    fm1_subj_org_form: "1.1 公司法律属性",
    fm1_subj_name: "1.2 名称",
    fm1_subj_pers_second_name: "1.2.1 姓氏",
    fm1_subj_pers_name: "1.2.2 名字",
    fm1_subj_pers_patronymic: "1.2.3 中间名（如有）",
    fm1_subj_rnn: "2.3 税务号码",
    fm1_subj_iin_bin: "2.4 个人/公司ID",
    fm1_address_group: "2.5 住所地址",
    state_kaz: "1. 区域（包括阿拉木图和阿斯塔纳）",
    region_kaz: "2. 地区",
    sity_kaz: "3. 地区（城市/城镇/村庄，不包括阿拉木图和阿斯塔纳）",
    street: "4. 街道",
    house_num: "5. 楼栋号",
    flat_num: "6. 公寓房号/办公室号（如有）",
    post_index: "7. 邮政编码",
    fm1_document_id_group: "2.6 身份证件（自然人）",
    fm_1_passport_group: "2.6.1 文件编号和序列号（自然人）",
    doc_num: "1. 编号",
    doc_series: "2. 序列号",
    goverm_office: "2.6.2 身份证件（自然人）签发人：",
    doc_date: "2.6.3 身份证件（自然人）签发时间：",
    fm1_responsive_person_group: "2.7 法律代表",
    fm1_subj_manager_second_name: "1. 姓氏",
    fm1_subj_manager_name: "2. 名字",
    fm1_subj_manager_patronymic: "3. 中间名（如有）",
    fm1_subj_position: "2.7.1 法律代表职位",
    fm1_subj_phone: "2.8 联系电话",
    fm1_subj_email: "2.9 电子邮箱",
    is_fiz_lico: "AML对象",
    fiz_lico: "自然人",
    yur_lico: "法人",
    fm1_tab3: "AML合规审查交易信息",
    fm1_tab3_short: "交易",
    fm1_oper_number: "3.1 交易编号",
    fm1_oper_code_type: "3.2 经营业务代码",
    fm1_oper_eknp: "3.3 付款事由代码",
    fm1_oper_members_quant: "3.4 交易方数量",
    fm1_oper_currency: "3.5 交易币种代码",
    fm1_oper_curr_code: "3.6 交易金额（币种）",
    fm1_oper_tenge_sum: "3.7 坚戈交易金额",
    fm1_oper_basis: "3.8 交易法律基础文件",
    fm1_oper_group: "3.9 交易法律基础文件日期及编号",
    fm1_oper_basis_doc_date: "1. 日期",
    fm1_oper_basis_doc_num: "2. 文件编号",
    fm1_oper_1code: "3.10 可疑交易代码",
    fm1_oper_2code: "3.11 第一补充可疑交易代码",
    fm1_oper_3code: "3.12 第二补充可疑交易代码",
    fm1_oper_trouble_desc: "3.13 划分可疑交易等级的困难描述",
    fm1_oper_add_info: "3.14 交易补充信息",

    fm1_tab4: "4. 可疑交易参与者信息",
    fm1_tab4_short: "参与者",
    fm1_members_fm1_member: "4.1 参与者（选择选项）",
    fm1_members_fm1_memb_is_subj: "4.2 AML对象海关（选择选项）",
    fm1_members_fm1_memb_subj_kind: "4.3 参与者类型",
    fm1_members_fm1_memb_country: "4.4 居留权",
    fm1_members_fm1_memb_type: "4.5 交易参与者类型（请选择）",
    fm1_members_fm1_memb_foreign: "4.6 外国部门代表（请选择）",

    fm1_member_bank: "4.7 交易参与者银行",

    fm1_members_fm1_memb_bank_branch_place: "1.1 分公司地址",
    fm1_members_fm1_memb_bank_branch: "1.2 银行名称",
    fm1_members_fm1_memb_sdp: "1.2.1 付款系统名称",
    fm1_members_fm1_memb_branch_code: "1.3 银行/分行代码",
    fm1_members_fm1_memb_acc: "1.4 参与者银行账号",
    fm1_correspondent_account: "1.5 交易对方银行地址",

    fm1_members_fm1_memb_bank_place: "1.5.1 银行地址",
    fm1_members_fm1_memb_bank_name: "1.5.2 银行名称",
    fm1_name_of_participant: "4.8 交易参与者职位（法人）",
    fm1_member_participant: "1. 参与者",

    fm1_members_fm1_memb_org_form: "1.1 法律类型",
    fm1_members_fm1_memb_company_name: "1.2 名称",
    fm1_members_fm1_memb_noname: "2 未定义",
    fm1_founders_of_member: "4.9 参与者股权信息（法人）",

    fm1_members_fm1_memb_founder_org_form: "1.1 法律文书",
    fm1_members_fm1_memb_founder_: "2.1 名称",
    fm1_members_fm1_memb_founder_secondname: "1.2.1 姓氏",
    fm1_members_fm1_memb_founder_name: "1.2.2 名字",
    fm1_members_fm1_memb_founder_patronymic: "1.2.3 中间名（如有）",
    fm1_members_fm1_memb_country: "2. 居留权",
    fm1_first_head: "4.10 公司CEO（法人）",

    fm1_persons_fm1_person_secondname: "1. 姓氏",
    fm1_persons_fm1_person_name: "2. 名字",
    fm1_persons_fm1_person_midle_name: "3. 中间名（如有）",
    fm1_members_oked: "4.12 经营业务代码",
    fm1_members_iin_bin: "4.13 个人/公司身份代码",
    fm1_memebers_fio: "4.14 全名（自然人和企业家）",

    fm1_persons_fm1_person_secondname: "1.1 姓",
    fm1_persons_fm1_person_name: "1.2 名称",
    fm1_persons_fm1_person_middle_name: "1.3 中间名（如有）",
    fm1_members_: "2.1 未定义的",
    fm1_docs_doc_type: "4.15 个人身份证明文件",
    fm1_docs_doc_type_first_head: "4.16 身份证明文件编号及序列号",

    fm1_docs_doc_num: "1. 数量",
    fm1_docs_doc_series: "2. 序列号（如有）",
    fm1_docs_goverm_office: "4.17 身份证文件签发人",
    fm1_docs_doc_date: "4.18 身份证文件签发日期",
    fm1_persons_fm1_person_birth_date: "4.19 出生日期（自然人和企业家）",
    fm1_persons_fm1_person_birth_place: "4.20 出生地点（自然人和企业家）",
    fm1_persons_yur_address: "4.21 法定地址(法人法定地址，自然人正式注册地址)",

    fm1_addrr_state_kaz: "1. 区域(包括阿拉木图和阿斯塔纳)",
    fm1_addrr_region_kaz: "2. 地区",
    fm1_addrr_sity_kaz: "3.地点(市/镇/村，不包括阿拉木图和阿斯塔纳):",
    fm1_addrr_street: "4. 街道",
    fm1_addrr_house_num: "5. 楼栋号",
    fm1_addrr_flat_num: "6. 公寓/办公室号码",
    fm1_addrr_post_index: "7. 邮编",
    fm1_members_fm1_memb_contact_phone: "4.22 联系电话",
    fm1_members_fm1_memb_email: "4.23 电子邮箱",
    fm1_members_fm1_memb_fact_address:
      "4.24 实际地址(法人所在地，自然人居住地址)",

    fm1_addrr_state_kaz: "1. 地区(包括阿拉木图和阿斯塔纳)",
    fm1_addrr_region_kaz: "2. 区",
    fm1_addrr_sity_kaz: "3.地点(市/镇/村，不包括阿拉木图和阿斯塔纳)",
    fm1_addrr_street: "4. 街道",
    fm1_addrr_house_num: "5. 楼栋号",
    fm1_addrr_flat_num: "6. 公寓/办公室号（如有）",
    fm1_addrr_post_index: "7. 邮编",
    fm1_members_fm1_memb_memb_add_info: "4.25 交易参与者补充信息",

    fm1_fm1_member_payer: "1. 交易发送者",
    fm1_fm1_member_recipient: "2. 交易受益人",
    fm1_fm1_member_payer_representative: "3. 发送方代表",
    fm1_fm1_member_recipient_representative: "4. 受益人代表",
    fm1_fm1_member_face_in_name_of: "5. 赞成人",
    fm1_fm1_member_beneficiary: "6. 最终受益者",
    fm1_memebers_memb_subj_is_not: "不是",
    fm1_memebers_memb_subj_is: "是",
    fm1_memb_type1: "1. 法人",
    fm1_memb_type2: "2. 自然人",
    fm1_memb_type3: "3. 企业家",
    fm1_memb_foreign1: "不是",
    fm1_memb_foreign2: "是",
    fm1_memb_foreign3: "附属于外国法定公共代表人的自然人",
    fm1_memb_org_form_1: "1 - SC",
    fm1_memb_org_form_2: "2 - LLP",
    fm1_memb_org_form_3: "3 - OSC",
    fm1_memb_org_form_4: "4 - JSC",
    fm1_memb_org_form_5: "5 - 未定义的",
    fm1_validate: "验证",
    fm1_kfm_xml: "发送至AML",

    //form api'',
    document_epi: "EPD",

    document_epi_tab_1: "总体信息",
    document_epi_tab_1_short: "总体",
    document_epi_tab_2: "委托信息",
    document_epi_tab_2_short: "委托",
    document_epi_tab_3: "寄件人-收货人",
    document_epi_tab_3_short: "寄件人-收货人",
    document_epi_tab_4: "货物交付信息",
    document_epi_tab_4_short: "交付",
    document_epi_tab_5: "商品类目 Gr. 31-47",
    document_epi_tab_5_short: "商品类目",
    document_epi_tab_6: "之前的文件Gr. 40",
    document_epi_tab_6_short: "文件",

    ap_main_reg_num: "Gr.A 边境申报编号",
    ap_main_country_code: "国家代码",
    ap_main_reg_date: "注册日期",
    ap_main_trans_kind_code: "目的代码",
    ap_main_transit_direction_code: "交付方式",
    ap_main_electronic_document_sign: "Gr.1 电子海关申报单代码",
    ap_main_declaration_kind: "货物报关具体代码",
    ap_main_subsoil_sign: "自然资源代码",
    ap_main_seal_number: "封条编号",
    ap_main_seal_quantity: "封条数量",
    ap_main_language_cuesad: "文档语言代码",
    ap_main_recipient_country_code: "文件提交海关机构代码",
    ap_main_movement_code: "交付用途代码",
    ap_main_transit_direction_code_1: "IM",
    ap_main_transit_direction_code_2: "EX",
    ap_main_transit_direction_code_3: "TR",
    ap_main_transit_direction_code_4: "IT",
    ap_main_transit_direction_code_5: "CW",

    ap_goods_group: "委托信息",
    ap_good_origin_country_name: "商品原产地",
    ap_good_specification_number: "规格数量",
    ap_good_specification_list_number: "规格页总数量",
    ap_good_total_goods_number: "Gr. 5 所有商品标题",
    ap_good_total_package_number: "Gr. 6 车辆上所有货物的运输地点数量",
    ap_good_total_sheet_number: "海关申报单总页数 DT/TD",
    ap_good_total_cust_cost: "Gr. 22 商品总成本",
    ap_good_cust_cost_currency_code: "Gr. 22 货币字符代码",

    ap_sender_group: "Gr.2 商品寄件人信息",
    ap_memb_organization_name: "标题",
    ap_memb_short_name: "短标题",
    ap_memb_bin: "公司ID",
    ap_memb_itn: "海关ID",
    ap_sender_org_address: "公司地址",
    ap_member_postal_code: "邮编地址",
    ap_member_country_name: "国家代码",
    ap_member_region: "地区（地区、州、省等）",
    ap_member_city: "位置",
    ap_member_street_house: "街道，楼栋号，办公室号",
    ap_recipient_group: "Gr.8收货人信息",
    ap_recipient_address: "公司地址",
    ap_lico_fin_ureg_group: "财务事务负责人",
    ap_lico_fin_ureg_address: "公司地址",
    ap_declarant_group: "商品申报者信息",
    ap_declarant_address: "公司地址",
    ap_person_declaraed_group: "海关申报方的详细信息 Gr. 54/ Gr 50 CD",
    ap_person_person_surname: "姓",
    ap_person_person_name: "名称",
    ap_person_person_middle_name: "中间名",
    ap_person_person_post: "位置",
    ap_person_contact_phone: "电话号码",
    ap_courier_group: "向海关申报的承运人信息50TD",
    ap_courier_address: "公司地址",
    ap_drivers_group: "司机信息",
    ap_person_reg_country_code: "车辆驾驶人居住地国家代码",
    ap_document_id: "身份证明文件",
    ap_send_rec_identity_card_code: "文档类型",
    ap_send_rec_identity_card_series: "文档编号",
    ap_send_rec_identity_card_number: "文档编号",
    ap_send_rec_identity_card_date: "文件发行日期",
    ap_send_rec_organization_name: "文档发布",

    ap_send_rec_identitry_card_code_1: "护照",
    ap_send_rec_identitry_card_code_2: "驾照",

    ap_transportations_place_group: "商品的位置 Gr. 30 DT",
    ap_transp_information_type_code: "信息类型",
    ap_transp_customs_office: "《海关条例》",
    ap_transp_customs_country_code: "海关当局国家代码",
    ap_transportations_transport_group:
      "商品运输信息 15а， 17, 17а， 18, 19, 21, 25, 26, 29 - CD/ Gr.15，17,18,19,21,25,26,29,53,55 - TD",
    ap_transp_container_indicator: "Gr.19 集装箱货物信息",
    ap_transp_dispatch_country_code: "Gr.15 起运国",
    ap_transp_destination_country_code: "Gr.17 目的国",
    ap_transportations_customs_group: "Gr.29 出入境海关管制局",
    ap_transp_customs_office_inout: "海关部门编码",
    ap_transp_customs_country_code_io: "欧亚经济联盟国家海关代码",
    ap_transp_date_expected_arrival: "预计到达日期",
    ap_transportations_transport_facilities_group:
      "Gr.18,26 到达/离开车辆的信息",
    ap_transp_transport_mode_code: "Gr.25 车辆类型代码",
    ap_transp_transport_nationality_code: "车辆国家字符代码",
    ap_transportations_transport_description_group: "车辆描述",
    ap_transp_vin: "底盘号(VIN)",
    ap_transp_transport_identifier: "车辆登记号",
    ap_transp_active_transport_identifier: "运营车辆注册ID",
    ap_transp_information_type_code_11: "11 - BWH",
    ap_transp_information_type_code_21: "21 - CWH",
    ap_transp_information_type_code_25: "25 - 免费仓库",
    ap_transp_information_type_code_31: "31 - 收货人仓库",
    ap_transp_information_type_code_41: "41 - 自产仓库(哈萨克斯坦)",
    ap_transp_information_type_code_52: "52 - 车辆",
    ap_transp_information_type_code_60: "60 - 被许可的海关监管区域",
    ap_transp_information_type_code_72: "72 - 海关管制区(白俄罗斯)",
    ap_transp_information_type_code_91: "91 - 存地点地址(白俄罗斯)",
    ap_transp_information_type_code_99: "99 - 其他临时存储站点",
    ap_transp_information_type_code_80: "80 - 经济特区",
    ap_good_data_group: "商品类目Gr. 31-47",
    ap_good_data_goods_numeric: "已申报的商品序号/清单内的商品编号",
    ap_good_data_list_numeric: "清单内商品编号",
    ap_good_data_goods_description: "标题",
    ap_good_data_gross_weight_quantity: "商品重量（kg）",
    ap_good_data_net_weight_quantity: "商品重量（kg）",
    ap_good_data_invoiced_cost: "商品价格/总价",
    ap_good_data_customs_cost: "商品海关总价",
    ap_good_data_statistical_cost: "商品统计价格",
    ap_good_data_goods_tnved_code: "Gr.33 HS商品编码(CU)",
    ap_good_data_origin_country_code: "原产地国家代码",
    ap_good_data_delivery_terms_string_code: "交付条款代码",

    save_product: "保存",
    add_doc: "",
    save_doc: "保存文件",
    epi_to_xml: "发送至海关",

    ap_prev_doc_group: "Gr.40 之前的文件",
    ap_prev_doc_preceding_document_date: "之前文件-日期",
    ap_prev_doc_preceding_document_number: "文件登记号",
    PrecedingDocumentName: "之前的文件标题",

    document_delete_message: "您确定要删除文档吗?",

    country: "国家",
    city: "城市",
    sphere: "经营范围",
    contr_search_name: "标题",

    contract_check_contragent: "检查买方/卖方吗?",
    good_selector: "商品或服务",
    good_selector_c1: "章",
    good_selector_c2: "节",
    good_selector_c3: "组",
    good_selector_c4: "级别",
    good_selector_c5: "标题",

    ap_main_decl_num: "Gr.A 在转关海关的申报编号",
    ap_main_decl_date: "Gr.50 在转关海关的申报日期",
    ap_main_carnet: "Gr.1 TIR运输方式代码",
    ap_transp_date_expected_arrival_time: "估计到达时间",
    ap_good_data_quant: "商品数量",
    ap_good_data_ext_measure: "增补，计量单位",
    ap_good_data_container_num: "集装箱号码",
    ap_prev_doc_kind: "文件代码",

    ap_good_data_places_group: "货物，货物位置，托盘和货物包装信息",
    ap_good_data_places: "商品货位总数量",
    ap_good_data_packet: "商品包装编码",
    ap_good_data_places_name: "货物位置类型",

    ap_good_data_packet_0: "0 - 无包装",
    ap_good_data_packet_1: "1 - 有包装",
    ap_good_data_packet_2: "",

    awb_1_airport_code: "1) 起飞机场代码",
    awb_1a_acompany_code: "1А) 航司代码",
    awb_1b_serial_num: "1B) AWB运单号",
    awb_1c_acomp_name_addr: "1С) 空运承运人名称和地址",
    awb_2_sender_name_addr: "2) 发件人姓名（职位）和地址",
    awb_4_recipient_name_addr: "4) 收货人姓名(头衔)和地址",
    awb_6_agent_name_addr: "4) 收货人姓名(头衔)和地址",
    awb_7_agent_iata_code: "7 代理的国际航空运输协会（IATA）代理代码",
    awb_8_agent_acc: "8 代理人银行账户",
    awb_9_dest_airport: "9 启运机场",
    awb_10_payment_data: "10 付款信息",
    awb_11a_first_carrier_dest_point: "11A 第一承运人目的地",
    awb_11b_fist_carrier_name: "11B 第一承运人名称（路线和目的地）",
    awb_11c_second_carrier_dest_point: "11C 第二承运人目的地",
    awb_11d_second_carrier_name: "11D 第二承运人名称",
    awb_11e_third_carrier_dest_point: "11E 第三承运人目的地",
    awb_11f_third_carrier_name: "11e 第三承运人名称",
    awb_12_curr_code: "12 所有金额的货币代码",
    awb_14a_pr_o: "14A 费用支付方法 - 以重量计",
    awb_14b_col_l: "14B 费用支付方法 - 以申报价值计",
    awb_15a_pr_d: "15A其他费用支付方式 - 以重量计",
    awb_15b_col_l: "15B 其他费用支付方法 - 以申报价值计",
    awb_16_decl_value_carr: "16 运输申报价值",
    awb_17_decl_value_cust: "17 申报价值",
    awb_18_dest_airport: "18 目的地机场",
    awb_19ab_flight_date: "19A或19B 航班/日期",
    awb_20_insuranse_amount: "20 保险金额",
    awb_21_handling_info: "21 货物处理信息",
    awb_21a_custom_status: "21A 货物报关状态",
    awb_22a_pieses_no: "22А 货场或可引起关税变更的地点的数量",
    awb_22b_brutto: "22В 毛重 ",
    awb_22c_measure: "22С 货物重量计量单位",
    awb_22d_rate_class: "22D 关税类别代号",
    awb_22e_commodity_item:
      "22Е 商品编号或折扣/保证金百分比或已包装货物运价类别",
    awb_22f_chargeable_weight: "22F 计费重量",
    awb_22g_rate_charge: "22G 已包装货物的运费或费用或折扣",
    awb_22h_total: "22Н 关税及费用总额",
    awb_22i_nature_quant: "22I 货物特性及数量",
    awb_22j_total_pieses: "22J 总货场数量、",
    awb_22l_total_sum_rev: "22L 总费用",
    awb_22k_total_brutto: "总毛重",
    awb_23_other_charges: "23 其他费用明细",
    awb_24_weight_charge_sum: "24А或24В 重量价格",
    awb_25_valuation_sum: "25А或25В 已声明的体积费用，",
    awb_26_tax_sum: "26А或26В 税金金额",
    awb_27_total_other_charges: "由代理人支付的` 其他费用，",
    awb_28_carrier_total_other_charges: "28А或28В 由承运人支付的其他费用，",
    awb_30_total_prepaid_collect: "空运单文件费用总额",
    awb_32a_awb_create_date: "31发货人签名”,",
    awb_32b_awb_place: "32В空运提单签发地点，",
    awb_32c_signature: "32С航空承运人-签单代表签字，",

    document_awb: ",",
    document_packaging: "装箱单",
    documents_packaging_number: "",
    documents_packaging_invoice: "发票",
    documents_packaging_products_count: "商品数量",
    documents_packging_list_for_invoice: "发票和装箱单",
    documents_packaging_list_invoce_by_contract: "合同号为*的发票",
    packaging_brutto_total: "总毛重”,",
    packaging_netto_total: "总净重",
    packaging_consignor: "收货人",
    packaging_consignee: "发货人",
    packaging_number_pp: "",
    packaging_goodsdescription: "货物描述",
    packaging_goodsquantity: "数量",
    packaging_placegoodsquantity: "货场的数量",
    packaging_places_tab: "货场总数量",
    packaging_transport_tab: "车",
    packaging_product_tab: "商品",
    packaging_products_modal: "装箱单中的商品",
    packaging_list_places_modal: "按类型划分的货场总数量",
    packaging_measureunitqualifiername: "计量单位",
    packaging_brutto: "商品毛重",
    packaging_netto: "商品净重",
    packaging_dimensions: "商品尺寸",
    packaging_goodsvolume: "商品体积",
    packaging_volumeunitqualifiername: "体积计量单位",
    packaging_goodmarking: "生产商代码",
    packging_placescount: "位置的数量",
    packaging_placesdescription: "货场描述",
    packaging_packagingtypecode: "包装类型代码",
    packaging_partialplacescount: "分批装货的货场数量",
    packaging_list_transport_tab: "车辆",
    packaging_transport_number: "",
    packaging_transporttypecode: "车辆类型代码",
    packaging_transportcountrycode: "车辆注册国",
    packaging_transportleading: "先导车",
    packaging_prouct_packaging_modal_title: "商品所在地",

    awb_31: "发货人签名",
    awb_22a_group: "22А至22L 关税事务雇佣详情",

    conditions_tab: "合同条款",
    confirm_removal: "你确定要删除合同吗？",
    close_document: "关闭文档",
    conditions_tab: "合同条款",
    attis_contract_conditions_overdue: "逾期付款利息百分比",
    attis_contract_conditions_packaging_transport_fees_included:
      "包装成本和其他费用都包括在内",
    attis_contract_conditions_goods_origin_country: "货物的原产国",
    attis_contract_conditions_point_of_departure: "起运点",
    attis_contract_conditions_destination_point: "目的地",
    attis_contract_conditions_days_to_change_price: "价格变化，天数",
    attis_contract_conditions_days_to_change_price_description:
      "卖方[供应商]有权更改货物的价格，但必须在变更前至少__天通知买方",
    attis_contract_conditions_prepayment_percent: "预付比例%",
    attis_contract_conditions_number_of_days_for_prepayment:
      "至预付款日期的天数",
    attis_contract_conditions_number_of_days_for_fullpayment:
      "至付全款日期的天数",
    attis_contract_conditions_overdue_term: "延迟期",
    attis_contract_conditions_shipping_term: "运输时间，天数",
    attis_contract_conditions_total_delivery_time: "总交货时间",
    attis_contract_conditions_days_to_receive_goods: "验收货物，天数",
    attis_contract_conditions_days_to_quality_receive_goods: "质量验收， 天数",
    attis_contract_conditions_transfer_of_ownership: "转让所有权",
    attis_contract_conditions_guarantee_term: "保修期",
    attis_contract_conditions_exceeding_guaranty_term: "超过保修期",
    attis_contract_conditions_payment_overdue: "延期付款，利息% ",
    attis_contract_conditions_shipping_overdue: "迟延装运，利息%",
    attis_contract_conditions_payment_overdue_description:
      "每天的滞纳金为逾期金额的_%",
    attis_contract_conditions_shipping_overdue_description:
      "每天的延误罚金为未装运货物价值的_%",
    attis_contract_conditions_decline_due_to_overdue: "因延误的拒收，天数",
    attis_contract_conditions_legal_country: "法律适用国",
    attis_contract_conditions_arbitrage_country: "仲裁机关",
    attis_contract_conditions_contract_language: "合同语言",
    attis_contract_conditions_contract_term: "合同期限",
    attis_contract_conditions_notification_term: "通知期限",
    russian: "俄文",
    english: "英文",
    chinese: "中文",
    select_ecp_type: "选择一个签名方式",
    only_for_kz: "哈萨克斯坦共和国居民，需要NCALayer",
    sign_with_ecp: "登录EDS",
    sign_with_code: "用代码登录",
    input_signature_code: "输入发送到你邮箱的代码",
    signed_message_signature: "EDS 已登入",
    signed_message_code: "代码已登入",
    contract_group_new: "新建",
    contract_group_mine: "我的合同",
    contract_group_participate: "我参与",
    paper_copy_packing: "装箱单",
    paper_copy_packing_no_logo: "装箱单（无标志）",
    document_rwb: "铁路提单",
    rwb_doc_id: "文档ID",
    rwb_refdocid: "文件编号",
    rwb_consignor_notice: "发货人通知",
    rwb_places_quantity: "地方数量",
    rwb_gross_weight_quantity: "毛重",
    rwb_departure_mode_description: "发送类型描述",
    rwb_loader_mode_description: "装载类型说明",
    rwb_additional_sheet_quantity: "额外页数",
    rwb_cargo_value: "货物成本",
    rwb_customs_notice: "海关通知",
    rwb_weight_definition_mode_description: "重量测定类型说明",
    rwb_carrier_notice: "承运人通知",
    rwb_commerce_akt: "商业法",
    rwb_prolongation: "延长",
    rwb_issue_marks: "问题标记",
    rwb_amount60: "数量 60",
    rwb_amount61: "数量 61",
    rwb_amount62: "数量 62",
    rwb_amount63: "数量 63",
    rwb_calculation_notice: "结算通知",
    wb_addition_payment: "额外付款",
    custom_code: "海关宣布的详细细节",
    courier_notes: "承运人条款和注释",
    cmr_docs: "附件清单",
    cmr_doc_type: "文件类型",
    cmr_doc_number: "文件编号",
    cmr_doc_date: "日期",
    save_place: "更新位置",
    broker_contract: "代理合同",
    broker_contract_no_logo: "代理合同（无标志）",
    bc_number: "数",
    bc_city: "城市",
    bc_date: "日期",
    bc_agreement: "协议",
    bc_penalty_amount: "罚款金额",
    bc_currency: "货币",
    bc_trial_city: "试行城市",
    bc_trial_language: "试行语言",
    add_place: "",
    cmr_places: "CMR 货场",
    close_document: "关闭文档",
    cmr_places_typecode: "包装类型",
    cmr_places_count: "货场数量",
    cmr_placesform_type_code: "包装/包装类型代码",
    cmr_placesform_places_count: "货场数量/包裹数量",
    cmr_placesform_places_description: "货场数量/包装说明",
    cmr_placesform_part_count: "被部分占用的货场或包装的数量",
    select_radio_button: "选择",
    update_fields_you_need: "更新您需要的字段",
    history_sftp_download: "SFTP文件下载",
    history_new_broker_contract: "新代理合同",
    history_update_broker_contract: "代理合同更新",
    history_delete_broker_contract: "代理合同删除",
    history_contract_owner_sign: "合同被业主签订",
    history_contract_contragent_sign: "合同经合约方签订",
    history_new_RWB: "新的铁路运单",
    history_update_RWB: "更新铁路运单",
    history_delete_RWB: "删除铁路运单",
    history_new_insurance: "新的保险",
    history_update_insurance: "更新保险",
    history_delete_insurance: "删除保险",
    history_new_liability_insurance: "新的责任保险",
    history_update_liability_insurance: "更新责任保险",
    history_delete_liability_insurance: "删除责任保险",
    transport_contract: "运输合同",
    cancel_term: "取消申请(以小时计)，",
    consent_term: "承运人同意(以小时计)",
    inform_term: "通知客户(以小时计)",
    location_term: "位置(以小时计)”,",
    fuel_percent: "柴油燃料成本的增加(%)",
    currency_percent: "汇率上升比例(%)",
    application_term: "应用(以小时计)",
    customs_term: "报关(以小时计)",
    payment_term: "付款(以天计)",
    delay_abroad_term: "国际运输的等待时间(以天计)",
    delay_home_term: "国内运输的中止时间(以天计)”,",
    courier_cis_delay_amount: "在独联体(坚戈)对车辆的最新申报",
    customer_cis_delay_amount: "在CIS(坚戈)中止期",
    courier_eu_delay_amount: "向欧盟对车辆的最新申报(坚戈)，",
    customer_eu_delay_amount: "在欧盟的等待期(坚戈)",
    courier_declination_percent: "基于承包商拒绝支付的合同罚款比例(%)",
    penalty_percent: "逾期付款罚款(%)",
    penalty_never_more: "罚款不超过(%)",
    customer_declination_percent: "客户拒绝支付的罚金(%)",
    act_term: "该法案被视为在(天)内签署，",
    repeats_term: "不可抗力持续时间(天)，",
    force_major_term: "主要通知期限(天)",
    claim_term: "申诉考虑期限(天)，",
    resolve_term: "争端解决机构”,",
    contract_term: "合同时间”,",
    contract_cancel_term: "终止通知期限(天)，",
    insurance_policy_holder_name: "“保单持有人姓名:”，",
    insurance_represented_by: "由(全名，职位)代表:",
    insurance_legal_address: "法定地址:,",
    insurance_actual_address: "实际地址:,",
    insurance_is_public_person:
      "“您是外国公众人士(待填、个人或个人企业家)吗?””,",
    insurance_insured_details: "“被保险人详情:”，",
    insurance_insured_activity: "“被保险人的活动类型:”",
    insurance_beneficiary: "“受益人:”,",
    insurance_beneficiary_details: "“受益人详情:”",
    insurance_shipping_name: "“运输名称:”,",
    insurance_package_info: "关于包装类型和特殊保护涂层的信息:",
    insurance_cargo_cost: "“一个包装件和(或)一个特别包裹内的货物价值:”，",
    insurance_package_count: "具有特殊防护涂层的包装和(或)物体的数量:",
    insurance_total_cost: "托运的总成本:",
    insurance_release_date: "货物出(产)期:",
    insurance_containerization: "集装箱化:是否完成?”,",
    insurance_cargo_placing: "“描述货物放置的方法(方法)和集装箱数量:”，",
    insurance_route: "“路线:”,",
    insurance_security_measures: "“安全措施:”,",
    insurance_transport_means: "货物运输是通过:",
    insurance_transfer_points: "“计划转换车辆类型的中转点:”",
    insurance_shipping_details: "“运输文件的细节:”",
    insurance_risk: "“承保风险:”,",
    insurance_risk_a: "条件A“一切风险自负”，",
    insurance_risk_b1: '条件B "部分事故责任"',
    insurance_risk_b2: '条件B "不承担损害赔偿责任"',
    insurance_additional_conditions: "“附加条款:”,",
    insurance_max_value: "货物的最高保险价值:",
    insurance_max_value_a: "A)在一个容器内，",
    insurance_max_value_b: "B)在一辆车上，",
    insurance_max_value_c: "C)在同一艘船上，",
    insurance_max_value_d: "D)在一架飞机上。",
    insurance_max_value_e: "E)在一节车厢上，",
    insurance_max_value_f: "“F)在一个存储的地方”，",
    insurance_insured_transport: "“投保金额包括运输费和保险费。”",
    insurance_insured_transport_amount: "“投保金额(本批货物):”",
    insurance_franchise: "“特许经营:”,",
    insurance_shipment_date: "装船日期:,",
    insurance_shipment_duration: "“运输时长”，",
    insurance_insurance_stats: "“统计数据:”,",
    insurance_insurance_stats_desc:
      "“请提供过去三年您的货物发生保险事故的统计数据(货物价值、发生的损失等)”，",
    insurance_relevant_info: "“请提供您认为与此风险相关的任何信息:”",
    insurance_other: "其他",
    document_insurance: "货物保险”,",
    document_liability_insurance: "民事责任保险”,",
    liability_insurance_policy_holder: "投保人’,",
    liability_insurance_policy_holder_name: "名称”,",
    liability_insurance_policy_holder_address: "位置”,",
    liability_insurance_policy_holder_phone: "电话号码的,",
    liability_insurance_policy_holder_email: "电子邮件”,",
    liability_insurance_policy_holder_bank: "银行详细信息”,",
    liability_insurance_policy_holder_bin: "本”,",
    liability_insurance_policy_holder_bik: "BIC’,",
    liability_insurance_is_resident: "居住证明,",
    liability_insurance_license_no: "牌照号码”,",
    liability_insurance_economy_sector: "经济部门",
    liability_insurance_activity_type: "经济活动的类型，",
    liability_insurance_object_teritory: "物体的地域特征",
    liability_insurance_insured_details: "保险”,",
    liability_insurance_insured_sum: "造成损害的保险金额，",
    liability_insurance_life_insured_sum: "第三方的生命和健康，",
    liability_insurance_property_insured_sum: "第三者的财产，",
    liability_insurance_cargo_insured_sum: "致货物所有人，",
    liability_insurance_insured_limit: "责任限额”,",
    liability_insurance_total_insured_sum: "“一切险累积责任限额”，",
    liability_insurance_insurance_term: "保险期限”,",
    liability_insurance_insurance_teritory: "境内保险”,",
    liability_insurance_transport_type: "运输类型,",
    liability_insurance_transport_h: "货运代理采用各种运输方式，",
    liability_insurance_transport_model: "模式”,",
    liability_insurance_transport_name: "标题”,",
    liability_insurance_transport_reg_number: "注册号”,",
    liability_insurance_transport_body_number: "体的数量,",
    liability_insurance_transport_release_date: "年的问题”,",
    liability_insurance_vehicles_number: "车辆数量,",
    liability_insurance_previous_insurance_info: "关于先前责任保险合同的信息，",
    liability_insurance_valid_contracts_info: "有效的民事责任自愿保险合同",
    liability_insurance_insurer: "有关保险公司代表、",
    liability_insurance_insurer_name: "公司全称、职务、法人(代理人)名称、",
    liability_insurance_insurer_address: "地址、位置”,",
    liability_insurance_insurer_phone: "电话(工作和手机)",
    liability_insurance_insurance_date: "提交申请日期",
    broker_select_radio_btn: "选择”,",
    upload_ktzh_answer: "下载答案KTZ’,",
    show_ktzh_request: "查看请求”,",
    show_ktzh_answer: "查看回复”,",
    send_insurance_request: "向保险公司发送申请，",
    download_insurance_certificate: "下载保险凭证”,",
    contract_history_data: "历史数据”,",
    pdf_aml: "公司确认,",
    pdf_aml_no_logo: "公司确认,（无标志）",

    rwb_consignor_option_notice: "“托运人备注”,",
    rwb_consignor: "“发货人”,",
    rwb_consignee: "“收货人”,",
    rwb_departure_station_code: "“出发站代码”,",
    rwb_departure_station_name: "“离开车站的名字”,",
    rwb_departure_rwcode: "出发站铁路站点代码，",
    rwb_departure_rwname: "“出发站铁路站点名称”，",
    rwb_departure_country: "“始发国家”,",
    rwb_destination_rwcode: "“目的地铁路站点代码”,",
    rwb_destination_station_code: "“目的地铁路站点名称”,",
    rwb_destination_rwand_station_name: "“终点站点名称”,",
    rwb_border_station_code: "“边境站点代码”,",
    rwb_border_station_name: "“边境站的名称”，",
    rwb_border_rwcode: "《边境站铁路代码》，",
    rwb_border_rwname: "“边境站铁路站点的名称”，",
    rwb_border_country: "“边境国家”,",
    rwb_contract_name: "合同名称，",
    rwb_contract_number: "“合同号”,",
    rwb_contract_date: "“合同日期”,",
    rwb_flat_pallet_quantity: "“平托盘数量”，",
    rwb_box_pallet_quantity: "“箱托数量”，",
    rwb_pallet_exchange_mode: "“托盘交换法”,",
    rwb_work_tool_id: "工具“ID”,",
    rwb_work_tool_container_description: "“工作工具容器描述”，",
    rwb_work_tool_railway_code: "“工作工具代码”,",
    rwb_mark_sing: "“标识”,",
    rwb_mark_kind: "“标识类型”,",
    rwb_mark_result_control: "“标识结果控制”,",
    rwb_contract_carrier_name: "“合同承运人名称”,",
    rwb_contract_carrier_time: "合同规定的在承运人停留时间",
    rwb_contract_carrier_date: "“合同项下承运人日期”，",
    rwb_contract_carrier_date_time_moscow:
      "“合同规定在承运人的日期和时间(MSK)”，",
    rwb_contract_carrier_date_time_moscow_date: "“在承运人的合同日期(MSK)”，",
    rwb_contract_carrier_date_time_moscow_time:
      "“合同规定的在承运人停留时间(MSK)”，",
    rwb_contract_carrier_station_code: "“合同承运人站点代码”，",
    rwb_contract_carrier_station_name: "“合同承运人站点名称”，",
    rwb_contract_carrier_rw_name: "“本合同项下铁路承运人名称”，",
    rwb_contract_carrier_country: "“合同承运人所属国家”,",
    rwb_arrival_carrier_name: "“目的站承运人名称”,",
    rwb_arrival_date: "“抵达日期”,",
    rwb_arrival_time: "“到达时间”,",
    rwb_arrival_date_time_moscow: "“到达日期和时间(MSK)”，",
    rwb_arrival_date_time_moscow_date: "“到达日期(MSK)”，",
    rwb_arrival_date_time_moscow_time: "“到达时间(MSK)”,",
    rwb_arrival_station_code: "“到达站代码”,",
    rwb_arrival_station_name: "“到达站的名字”,",
    rwb_arrival_rw_name: "“到达铁路名称”,",
    rwb_arrival_rw_code: "“到达铁路代码”,",
    rwb_arrival_country: "“目的地国家”,",
    rwb_good_container_indicator: "运输容器”,",
    rwb_good_work_tool_description: "工作的工具”,",
    rwb_good_conductor_description: "引导描述”,",
    rwb_good_place_goods_quantity: "数量”,",
    rwb_good_places_quantity: "座位的数量,",
    rwb_good_gross_weight_quantity: "毛重,",
    rwb_good_places_description: "描述的地方”,",
    rwb_good_harmonized_range_goods: "在税则中的产品范围”,",
    rwb_good_packing: "包装”,",
    rwb_good_marking: "TNVED’,",
    rwb_good_carriage_number: "车厢的数量,",
    rwb_good_container_number: "容器号”,",
    rwb_good_goods_numeric: "货物编码”,",
    rwb_good_customs_code: "海关代码”,",
    rwb_good_gtd_number: "GTD的数量,",
    rwb_good_gcost: "价格,",
    rwb_good_currency: "货币”,",
    rwb_good_mrn: "MRN’,",
    rwb_carrier_id: "ID”,",
    rwb_carrier_carrier_name: "承运人名称”,",
    rwb_carrier_carrier_code: "承运人代码”,",
    rwb_carrier_from_station_code: "出发站点代码”,",
    rwb_carrier_from_station_name: "出发站点名称”,",
    rwb_carrier_from_rw_name: "出发地点的铁路站点名称，",
    rwb_carrier_from_country: "出发地所属国家”,",
    rwb_carrier_to_station_code: "目标代码”,",
    rwb_carrier_to_station_name: "目的地名称”,",
    rwb_carrier_to_rw_name: "铁路名称目的地”,",
    rwb_carrier_to_country: "目的地国家”,",
    rwb_carrier_tech_station: "铁路技术站”,",
    rwb_carrier_tech_station_order_number: "订单号,",
    rwb_carrier_tech_station_tech_signs: "标识,",
    rwb_carrier_tech_station_station_code: "车站代码”,",
    rwb_carrier_tech_station_station_name: "车站的名字”,",
    rwb_carrier_tech_station_rw_name: "铁路名称”,",
    rwb_carrier_tech_station_country: "国家名称",
    rwb_container_container_id: "运输容器ID”,",
    rwb_container_rw_code: "铁路代码”,",
    rwb_container_container_kind: "运输容器类型”,",
    rwb_container_container_mode_desc: "模式描述”,",
    rwb_container_container_capacity: "装载能力”,",
    rwb_container_container_capacity_unit_code: "计量单位”,",
    rwb_container_tare: "运输容器”,",
    rwb_container_goods_weight: "货物重量”,",
    rwb_container_places_quentity: "货物的数量,",
    rwb_container_pocket_quentity: "袋装的数量,",
    rwb_container_container_length: "容器的长度,",
    rwb_auto_vin: "VIN",
    rwb_auto_transport_kind: "车辆类型”,",
    rwb_auto_transport_mark: "车辆品牌”,",
    rwb_auto_transport_identifier: "车辆ID”,",
    rwb_auto_transport_nationality: "车辆的注册国家”,",
    rwb_auto_active_transport_identifier: "活动车辆ID”,",
    rwb_auto_transport_regnumber: "注册号”,",
    rwb_auto_wagon_number: "车的数量,",
    rwb_auto_tare: "运输容器”,",
    rwb_auto_goods_weight: "货物重量”,",
    rwb_auto_places_quentity: "货物的数量,",
    rwb_auto_pocket_quentity: "袋装的数量,",
    rwb_auto_container_length: "运输容器的长度,",
    rwb_carriage_carriage_id: "车厢ID”,",
    rwb_carriage_rw_name: "铁路名称”,",
    rwb_carriage_owner_name: "车厢的所有人”,",
    rwb_carriage_owner_type: "所有者类型”,",
    rwb_carriage_rw_power: "铁路电力”,",
    rwb_carriage_axis_quentity: "车辆的轴数",
    rwb_carriage_tare: "运输容器”,",
    rwb_carriage_goods_weight: "货物重量”,",
    rwb_carriage_caliber: "容器口径”,",
    rwb_seal_seal_id: "ID”,",
    rwb_seal_seal_quentity: "数量”,",
    rwb_seal_ident_kind: "视图”,",
    rwb_seal_ident_desc: "描述,",
    rwb_stamp_carrier_name: "承运人名称”,",
    rwb_stamp_date: "日期”,",
    rwb_stamp_time: "时间”,",
    rwb_stamp_date_time_moscow: "日期和时间(MSK)",
    rwb_stamp_date_time_moscow_date: "日期(MSK)”,",
    rwb_stamp_date_time_moscow_time: "时间(MSK)”,",
    rwb_stamp_station_code: "车站代码”,",
    rwb_stamp_station_name: "车站的名字”,",
    rwb_stamp_rw_name: "铁路名称”,",
    rwb_stamp_rw_code: "铁路代码”,",
    rwb_stamp_country: "国家”,",
    rwb_carrier_charge_order_no: "订单号,",
    rwb_carrier_charge_carrier_code: "航空公司代码”,",
    rwb_carrier_charge_from_station_code: "出发站codeод станции отправления",
    rwb_carrier_charge_from_station_name: "出发车站的名字”,",
    rwb_carrier_charge_from_rw_name: "铁路出发站名称，",
    rwb_carrier_charge_from_country: "出发站的国家”,",
    rwb_carrier_charge_to_station_code: "目的站代码”,",
    rwb_carrier_charge_to_station_name: "终点站的名字”,",
    rwb_carrier_charge_to_rw_name: "目的地铁路站点名称”,",
    rwb_carrier_charge_to_country: "目的地国家”,",
    rwb_carrier_charge_distance: "距离”,",
    rwb_carrier_charge_calc_weight: "估计重量”,",
    rwb_carrier_charge_extra_charge_code: "额外的费用代码”,",
    rwb_carrier_charge_extra_charge_name: "附加货板名称",
    rwb_carrier_charge_extra_charge_amount: "额外费用",
    rwb_carrier_charge_tarif_code: "票代码”,",
    rwb_carrier_charge_calc_cargo_code: "货物计算代码”,",
    rwb_carrier_charge_currency_rate: "比率”,",
    rwb_carrier_charge_snd_tarif_currency_code: "SND关税货币”,",
    rwb_carrier_charge_snd_payment_currency: "SND`的支付货币，",
    rwb_carrier_charge_rcv_tarif_currency_code: "RCV票价货币”,",
    rwb_carrier_charge_rcv_payment_currency: "付款货币”,",
    rwb_carrier_charge_amount48: "数额 48,",
    rwb_carrier_charge_amount49: "数额 49,",
    rwb_carrier_charge_amount50: "数额 50,",
    rwb_carrier_charge_amount51: "数额 51,",
    rwb_carrier_charge_amount52: "数额 52,",
    rwb_carrier_charge_amount53: "数额 53,",
    rwb_carrier_charge_amount54: "数额 54,",
    rwb_carrier_charge_amount55: "数额 55,",
    rwb_carrier_charge_amount56: "数额 56,",
    rwb_carrier_charge_amount57: "数额 57,",
    rwb_carrier_charge_amount58: "数额 58,",
    rwb_carrier_charge_amount59: "数额 59,",
    rwb_paid_rw_code_paid_rw_name: "铁路名称”,",
    rwb_paid_rw_code_paid_rw_code: "铁路站点代码”,",
    rwb_paid_rw_code_paid_rw_short: "短名称”,",
    rwb_paid_rw_code_payer_code: "付款方代码”,",
    rwb_paid_rw_code_payer_name: "付款人的名字,",
    rwb_paid_rw_code_from_rw_name: "铁路出发站点”,",
    rwb_paid_rw_code_from_country: "出发站点的国家”,",
    rwb_consignor_doc_doc_name: "“文件名称”,",
    rwb_consignor_doc_doc_number: "文件编号”,",
    rwb_consignor_doc_doc_date: "文档日期”,",
    rwb_consignor_doc_mode_code: "视图代码”,",
    rwb_consignor_doc_expiration_date: "任务结束日期”,",
    rwb_consignor_doc_release_customs: "通关”,",
    rwb_tab_data: "数据”,",
    rwb_tab_goods: "商品”,",
    rwb_tab_carrier: "承运人,",
    rwb_tab_carrier_charge: "运费",
    rwb_tab_transport: "运输,",
    rwb_tab_container: "运输容器”,",
    rwb_tab_auto: "汽车",
    rwb_tab_carriage: "车厢”,",
    rwb_tab_seal_stamp: "关封",
    rwb_tab_seal: "关封",
    rwb_tab_stamps: "关封",
    rwb_tab_paid_rw_code: "铁路付款”,",
    rwb_tab_consignor_doc: "文件”,",
    document_epi: "“EPI”,",
    document_epi_tab_1: "“一般信息”,",
    document_epi_tab_1_short: "“一般”,",
    document_epi_tab_2: "“货物信息”，",
    document_epi_tab_2_short: "“商品信息”,",
    document_epi_tab_3: "“发送方接收方”,",
    document_epi_tab_3_short: "“发送方接收方”,",
    document_epi_tab_4: "“货物运输信息”，",
    document_epi_tab_4_short: "“运输”,",
    document_epi_tab_5: "“商品类别属于31-47部分”，",
    document_epi_tab_5_short: "“商品类别”,",
    document_epi_tab_6: "“此前文件上的商品类别40”",
    document_epi_tab_6_short: "“文件”,",
    ap_main_reg_num: "“GR. A 初步信息注册号”，",
    ap_main_country_code: "“国家代码”,",
    ap_main_reg_date: "“登记日期”,",
    ap_main_trans_kind_code: "“目标代码”,",
    ap_main_transit_direction_code: "”交通工具的类型”,",
    ap_main_electronic_document_sign: "“g .1 ED签名”，",
    ap_main_declaration_kind: "“产品声明特征代码”，",
    ap_main_subsoil_sign: "地下使用者的标志。RK”,",
    ap_main_seal_number: "关封员在TD的代码",
    ap_main_seal_quantity: "“在TD应用的密封件数量”，",
    ap_main_language_cuesad: "“文档语言代码”,",
    ap_main_recipient_country_code: "“提交该文件的海关当局的国家代码”，",
    ap_main_movement_code: "进入TD的目的",
    ap_main_movement_code_code: "在TD运输目的代码",
    ap_main_transit_direction_code_1: '"IM",',
    ap_main_transit_direction_code_2: '"EC",',
    ap_main_transit_direction_code_3: '"TR",',
    ap_main_transit_direction_code_4: '"WT",',
    ap_main_transit_direction_code_5: '"TS",',
    ap_goods_group: "“货物信息”，",
    ap_good_origin_country_name: "“货物原产国”，",
    ap_good_specification_number: "“所有规格”,",
    ap_good_specification_list_number: "“规格单总数量”，",
    ap_good_total_goods_number: "“Gr.5货物总项目”，",
    ap_good_total_package_number: "“Gr.6总包装件数”，",
    ap_good_total_sheet_number: "“DT/TD”表的数量，",
    ap_good_total_cust_cost: "“g .22货物总成本”，",
    ap_good_cust_cost_currency_code: "“g .22字母货币代码”，",
    ap_sender_group: "“Gr.2关于发货人的信息”",
    ap_memb_organization_name: "“名称”,",
    ap_memb_short_name: "“短标题”,",
    ap_memb_bin: "“BIN”,",
    ap_memb_itn: "“ITN”,",
    ap_sender_org_address: "“组织的地址”,",
    ap_member_postal_code: "“邮政编码”,",
    ap_member_country_name: "“国家代码”,",
    ap_member_region: "“地区(地区、州、省等)”，",
    ap_member_city: "“位置”,",
    ap_member_street_house: "“街道，门牌号，办公室号码”，",
    ap_recipient_group: "“g .8货物收货人信息”，",
    ap_recipient_address: "“组织的地址”,",
    ap_lico_fin_ureg_group: "“财务结算负责人”，",
    ap_lico_fin_ureg_address: "“组织的地址”,",
    ap_declarant_group: "“货物报关员信息”，",
    ap_declarant_address: "“组织的地址”,",
    ap_person_declaraed_group: '“填写申报表的申报人信息。54号规定/ 50 TD"，',
    ap_person_person_surname: "“姓”,",
    ap_person_person_name: "“名称”,",
    ap_person_person_middle_name: "“中间名”,",
    ap_person_person_post: "“职位”,",
    ap_person_contact_phone: "“电话号码”,",
    ap_courier_group: "“50td航母信息”，",
    ap_courier_address: "“组织的地址”,",
    ap_drivers_group: "“车辆驾驶者资料”、",
    ap_person_reg_country_code: "《车辆驾驶人登记国家代码》，",
    ap_document_id: "“身份证件”,",
    ap_send_rec_identity_card_code: "“文档类型代码”,",
    ap_send_rec_identity_card_series: "一系列文件",
    ap_send_rec_identity_card_number: "“文件编号”,",
    ap_send_rec_identity_card_date: "“文档发行日期”,",
    ap_send_rec_organization_name: "发出文件的组织名称",
    ap_send_rec_identitry_card_code_1: "“护照”,",
    ap_send_rec_identitry_card_code_2: "“驾照”,",
    ap_transportations_place_group: "“商品的位置。Gr。30 DT”,",
    ap_transp_information_type_code: "“信息类型”,",
    ap_transp_customs_office: "“海关部门”,",
    ap_transp_customs_office_code: "《海关机构规范》，",
    ap_transp_customs_country_code: "“海关国家代码”,",
    ap_transportations_transport_group:
      "关于货物的运输信息。Gr. 15, 15a, 17, 17a, 18, 19, 21, 25, 26, 29 - DT / Gr. 15, 17, 18, 19, 21, 25, 26, 29, 53, 55 - TD”，",
    ap_transp_container_indicator: "“第19号集装箱运输标志”，",
    ap_transp_dispatch_country_code: "“第15 出发地国家”，",
    ap_transp_destination_country_code: "第17 目的地国家”，",
    ap_transportations_customs_group: "“第29 入境/出境海关，",
    ap_transp_customs_office_inout: "海关机构代码",
    ap_transp_customs_country_code_io: "“海关联盟成员国的国家代码”，",
    ap_transp_date_expected_arrival: "“预计到达日期”，",
    ap_transportations_transport_facilities_group:
      "“gr.18.26 .到达/离开的车辆”，",
    ap_transp_transport_mode_code: "“Gr.25车型代号”，",
    ap_transp_transport_nationality_code: "“车辆所有人所属国的字母代码”，",
    ap_transportations_transport_description_group: "“车辆描述”,",
    ap_transp_vin: "“车架号(VIN)”,",
    ap_transp_transport_identifier: "“车辆数”,",
    ap_transp_active_transport_identifier: "“活动车辆ID”,",
    ap_transp_information_type_code_11: '"11 - TSW",',
    ap_transp_information_type_code_21: '"21 - TS",',
    ap_transp_information_type_code_25: "“25 -免费仓库”，",
    ap_transp_information_type_code_31: "“31 -收货人仓库”，",
    ap_transp_information_type_code_41:
      "“41 -储存自有货物的仓库(为哈萨克斯坦共和国)”，",
    ap_transp_information_type_code_52: "“52 车辆”,",
    ap_transp_information_type_code_60: "“60 -处所(地点)AEO”，",
    ap_transp_information_type_code_72: "“72 - ZTK(白俄罗斯)”，",
    ap_transp_information_type_code_91: "“91 -存储位置地址(白俄罗斯)”，",
    ap_transp_information_type_code_99: "99 - 其他地址 VX",
    ap_transp_information_type_code_80: '"80 - SEZ.",',
    ap_good_data_group: "“商品类别31-47”，",
    ap_good_data_goods_numeric: "“申报货物的序号/清单所列货物编号/”，",
    ap_good_data_list_numeric: "“清单中的货物编号”，",
    ap_good_data_goods_description: "“名称”,",
    ap_good_data_gross_weight_quantity: "货物重量，毛重(公斤)，",
    ap_good_data_net_weight_quantity: "“货物重量、净重(公斤)”",
    ap_good_data_invoiced_cost: "“商品价格/价值”，",
    ap_good_data_customs_cost: "《货物完税价格》、",
    ap_good_data_statistical_cost: "“商品统计成本”，",
    ap_good_data_goods_tnved_code: "“Gr.33 TN VED TS规则中产品代码”，",
    ap_good_data_origin_country_code: "“原产国代码”，",
    ap_good_data_delivery_terms_string_code: "“交货条件代码”,",
    save_product: "“保存”,",
    add_doc: "“添加文件”,",
    save_doc: "“保存文件”,",
    epi_to_xml: "“发送到”,",
    ap_prev_doc_group: "“Gr.40前一个文件”,",
    ap_prev_doc_preceding_document_date: "“先前文件-日期”，",
    ap_prev_doc_preceding_document_number: "“文档注册号”,",
    PrecedingDocumentName: "“前一个文件的名称”，",
    document_delete_message: "“您确定要删除该文档吗?”",
    good_selector: "“产品或服务”,",
    good_selector_c1: "“章”,",
    good_selector_c2: "“部门”,",
    good_selector_c3: "“集团”,",
    good_selector_c4: "“类”,",
    good_selector_c5: "“名称”,",
    ap_main_decl_num: "“Gr.A内部TD号码”，",
    ap_main_decl_date: "“第50 TD签发日期”，",
    ap_main_carnet: "“第1 TIR通行证运输标志”，",
    ap_transp_date_expected_arrival_time: "“预计到达时间”,",
    ap_good_data_quant: "“数量的商品”,",
    ap_good_data_ext_measure: "“增加 单位测量”,",
    ap_good_data_container_num: "“容器”,",
    ap_prev_doc_kind: "“文档代码”,",
    ap_good_data_places_group: "“货物、包装、托盘及货物包装信息”，",
    ap_good_data_places: "“货物所占包装总数”，",
    ap_good_data_packet: "“产品包装可用性代码”",
    ap_good_data_places_name: "“包类型的名称”，",
    ap_good_data_packet_0: "“0 -不包装”，",
    ap_good_data_packet_1: "“1 -带包装”，",
    ap_good_data_packet_2: "“2 -在车辆配备的容器内不进行包装”，",

    pdf_insurance: "Cargo insurance",
    pdf_insurance_no_logo: "Cargo insurance (No logo)",
    insurance_pdf_title: "APPLICATION - QUESTIONNAIRE",
    insurance_pdf_subtitle: "to conclude a cargo insurance contract",
    insurance_pdf_subsubtitle:
      "Please endorse any corrections and additions. Please fill in capital letters.",
    insurance_pdf_footer_title: "Declaration of the Insured:",
    insurance_pdf_p_1:
      'By signing this application form, as well as the insurance contract, the Policyholder gives the Insurer (including the Insurer`s parent organization and subsidiaries of the Insurer`s parent organization) its consent to the collection and processing of personal data in accordance with the Law of the Republic of Kazakhstan "On Personal Data and their Protection", including the accumulation , use, change (addition, update), storage, distribution, depersonalization, blocking, destruction of personal data, as well as their consent to communicate with the Policyholder, including receiving newsletters. Consent is considered valid if it is not revoked at the written request of the Insured.',
    insurance_pdf_p_2:
      "The insurer has the right to verify the accuracy of the personal data provided, including using other available sources.",
    insurance_pdf_p_3:
      "I hereby declare that the information specified in the Application-questionnaire is correct and does not contain false information or any inaccuracies, and I have provided all essential information in accordance with the requirement of the Insurer. I am also aware of the consequences for providing false information about the object of insurance, the insured risk, the insured event and its consequences.",
    insurance_pdf_p_4:
      "I also confirm that this Application-questionnaire will serve as the basis for the conclusion of the Insurance Contract.",
    insurance_pdf_p_5:
      'I have read/received a copy of the Rules for Voluntary Cargo Insurance of JSC "Insurance Company "{{company}}".',
    insurance_pdf_p_6_b: "Notification.",
    insurance_pdf_p_6:
      "The Insurer reserves the right to terminate the Insurance Policy and/or refuse to make an insurance payment if the Policyholder hereby provided false information or concealed any material information in order to conclude the Insurance Policy, as well as on the grounds provided for by the Law of the Republic of Kazakhstan “On combating the legalization (laundering) of proceeds from crime and the financing of terrorism”.",
    insurance_pdf_insurer: "Policyholder",
    insurance_pdf_signature: "Signature",
    insurance_pdf_date: "the date",
    insurance_pdf_footer1: "Insurance premium rate",
    insurance_pdf_footer2: "The insurance payment is calculated in the amount",
    insurance_pdf_footer3: "Representative of JSC Insurance Company",
    insurance_pdf_0: "Name of the Policyholder:",
    insurance_pdf_1: "represented by (full name, position):",
    insurance_pdf_1: "Legal address:",
    insurance_pdf_1: "The actual address:",
    insurance_pdf_1:
      "Are you a foreign public person (to be completed, individual or individual entrepreneur)?",
    insurance_pdf_1: "Details of the Insured:",
    insurance_pdf_2: "Type of activity of the Insured:",
    insurance_pdf_3: "Beneficiary:",
    insurance_pdf_4: "Details of the Beneficiary:",
    insurance_pdf_5: "Shipping Name:",
    insurance_pdf_6:
      "Information about the type of packaging and special protective coatings:",
    insurance_pdf_7:
      "The cost of cargo in one package and (or) in one special cover:",
    insurance_pdf_8:
      "Number of packages and (or) objects in special protective coatings:",
    insurance_pdf_9: "The total cost of the consignment:",
    insurance_pdf_10: "Date of issue (production) of the cargo:",
    insurance_pdf_11: "Containerization: Complete?",
    insurance_pdf_12:
      "Describe the way (method) of cargo placement and the number of containers (wagons, trailers, bulk, bulk, etc.):",
    insurance_pdf_13:
      "Route: (indicate the details of the exact route of transportation, as well as the points of transshipment and transshipment, including the warehouse of departure and warehouse of destination):",
    insurance_pdf_14: "Security measures taken:",
    insurance_pdf_15:
      "Transportation of goods is carried out by means of (mode of transport):",
    insurance_pdf_16:
      "Transfer points where it is planned to change the type of vehicle (also indicate all temporary storage warehouses):",
    insurance_pdf_17: "Details of shipping documents:",
    insurance_pdf_18: "Insured risks:",
    insurance_pdf_19: 'Condition A "With responsibility for all risks"',
    insurance_pdf_20: 'Condition B "With liability for a partial accident"',
    insurance_pdf_21: 'Condition B "No liability for damages"',
    insurance_pdf_22: "Additional terms:",
    insurance_pdf_23: "Maximum insured value of cargo:",
    insurance_pdf_24: "A) in one container",
    insurance_pdf_25: "B) in one vehicle",
    insurance_pdf_26: "B) on the same ship",
    insurance_pdf_27: "D) on one aircraft",
    insurance_pdf_28: "D) on one railway car",
    insurance_pdf_29: "E) in one place of storage",
    insurance_pdf_30: "The sum insured includes transport and insurance costs.",
    insurance_pdf_31: "If YES, please indicate the amount:",
    insurance_pdf_32: "Sum insured (for consignment):",
    insurance_pdf_33: "Franchise:",
    insurance_pdf_34: "Shipment date:",
    insurance_pdf_35: "Time spent on the way",
    insurance_pdf_36:
      "Provide statistical data on any insured events that have occurred with your cargo over the past three years (cargo value, losses incurred, etc.):",
    insurance_pdf_37:
      "Please provide any information that you think is relevant to this risk:",
    insurance_pdf_38: "Other:",
  },
  help: {
    registration: "用户注册",
    document: "文件",
    transport_offer: "运输需求",
    contract_offer: "合同订单",
    contract_signature: "合同签订",
    new_contract: "合同申请",
    contract_add_contragent: "合同添加合约方",
    pa_personal: "个人的",
    pa_legal: "法人单位个人领域",
    contragent_check: "搜寻及核实合约方",
    export_import: "进出口",
    epi: "EPI",
  },
  navigation: {
    never_show_again: "不要再显示",
    registration: "第一步您需要注册",
    register: "注册",
    auth: "现在您需要通过授权",
    login: "进入",
    search_partner: "搜索一个合作伙伴",
    find_a_partner: "您需要根据所选的参数找到一个合作伙伴",
    check_partner: "检查合作伙伴",
    find_a_partner_message:
      "若要搜寻合作伙伴，请选择所需选项，然后点击“搜寻”，",
    find_a_partner_message_result:
      "您需要勾选需检查的合作伙伴，然后点击“检查”， ",
    next_create_contract:
      "在检查了合作伙伴后，您需要创建一份合同。 如需，请到“合同”模块  ",
    create_contract: "创建一份合同",
    to_create_contract_message: "为了创建合同，请点击“创建合同”按钮",
    save_contract_message: "填写完合同后 - 请点击“保存合同”以保存",
    save_contract: "保存合同",
    open_contract_message: "合同已创建，打开",
    open_contract: "打开合同",
    sign_contract_message: "现在合同需要被签订",
    sign_contract: "签订合同",
    contract_offers_message: "创建或查看合同提案",
    create_offer: "打开",
    contract_couriers_message: "创建或查看运输订单",
    contract_brokers_message: "创建或查看代理订单",
    contract_docs_message: "创建发票、箱单、运单、保单，然后到EXIM标签",
    create_documents: "创建文件",
    contract_docs_invoice_message: "从发票开始创建文件",
    create_invoice: "创建发票",
    contract_docs_packing_list_message: "现在您需要创建一份箱单",
    create_packing_list: "创建箱单",
    contract_docs_cmr_message: "",
    create_cmr: "创建一份CMR",
    contract_docs_insurance_message: "现在您需要创建货物保单",
    create_insurance: "创建保单",
    contract_docs_liability_insurance_message: "现在创建您的民事责任保险，",
    create_liability_insurance: "创建保单",
    contract_docs_exim_message: "现在前往EXIM",
    create_exim_insurance: "前往",
  },
  admin: {
    serviceprices: "Services pricelist",
    serviceprices: "Services pricelist",
    service_code: "Code",
    service_name: "Serice name",
    service_price: "Price",
    actions: "Actions",
    add_service: "Add service",
    edit_service: "Edit service",

    sad_builder_type: "",
    active: "注册",
    registrations: "注册",
    users: "用户",
    logs: "日志",
    operations: "运行",
    index: "管理面板",
    lock_user: "禁用",
    unlock_user: "启用",
    oper_code: "运行",
    log_source_user_id: "事项发起者用户",
    log_target_user_id: "用户事项目标",
    doc_id: "文件",
    stop: "停止",
    start: "发射",
    request_date: "申请日期",
    attis_status: "ATTIS模式",
    stop_confirmation: "警告！ATTIS系统将停止",
    start_confirmation: "注意！ATTIS系统将投入使用。",
    registration_approved: "申请已批准",
    log_date: "运输日期",
    is_error: "错误",
    data: "数据",
    "toc-offers": "订单",
    "toc-offer-active": "有效的",
    "toc-offer-inactive": "无效的",
    download: "下载",
    offer_file: "其它文件",
    offer_diff: "报价中的变化",
    offer_start_date: "生效日期",
    offer_end_date: "结束日期",
    offer_status: "状态",
  },
  validation: {
    PA1_Addr_W_001_name: "",
    PA1_Addr_W_001_message: "",
    PA1_Addr_W_002_name: "",
    PA1_Addr_W_002_message: "",
    PA1_Addr_W_003_name: "",
    PA1_Addr_W_003_message: "",
    PA1_Addr_W_004_name: "",
    PA1_Addr_W_004_message: "",
    PA1_Addr_W_005_name: "",
    PA1_Addr_W_005_message: "",
    PA1_Addr_W_006_name: "",
    PA1_Addr_W_006_message: "",
    PA1_Addr_W_007_name: "",
    PA1_Addr_W_007_message: "",
    PA1_Addr_W_008_name: "",
    PA1_Addr_W_008_message: "",
    PA1_Addr_W_009_name: "",
    PA1_Addr_W_009_message: "",
    PA1_Fndr_W_001_name: "",
    PA1_Fndr_W_001_message: "",
    PA1_Acc_W_002_name: "",
    PA1_Acc_W_002_message: "",
    PA1_Main_E_001_name: "",
    PA1_Main_E_001_message: "",
    PA1_Main_W_002_name: "",
    PA1_Main_W_002_message: "",
    PA1_Main_W_003_name: "",
    PA1_Main_W_003_message: "",
    PA1_Main_W_004_name: "",
    PA1_Main_W_004_message: "",
    PA1_Main_W_005_name: "",
    PA1_Main_W_005_message: "",
    PA2_Main_W_001_name: "",
    PA2_Main_W_001_message: "",
    PA2_Main_W_002_name: "",
    PA2_Main_W_002_message: "",
    CN1_Main_W_001_name: "",
    CN1_Main_W_001_message: "",
    CN1_Main_W_002_name: "",
    CN1_Main_W_002_message: "",
    CN1_Main_W_003_name: "",
    CN1_Main_W_003_message: "",
    CN1_Main_W_004_name: "",
    CN1_Main_W_004_message: "",
    Inv_Main_E001_name: "",
    Inv_Main_E001_message: "",
    Inv_Main_E002_name: "",
    Inv_Main_E002_message: "",
    Inv_Main_W003_name: "",
    Inv_Main_W003_message: "",
    Inv_Main_W004_name: "",
    Inv_Main_W004_message: "",
    Inv_Main_W005_name: "",
    Inv_Main_W005_message: "",
    Inv_Main_W006_name: "",
    Inv_Main_W006_message: "",
    Inv_Goods_E001_name: "",
    Inv_Goods_E001_message: "",
    Inv_Goods_E002_name: "",
    Inv_Goods_E002_message: "",
    Inv_Goods_E003_name: "",
    Inv_Goods_E003_message: "",
    Inv_Goods_E004_name: "",
    Inv_Goods_E004_message: "",
    Inv_Goods_E005_name: "",
    Inv_Goods_E005_message: "",
    Inv_Goods_E006_name: "",
    Inv_Goods_E006_message: "",
    Inv_Goods_E007_name: "",
    Inv_Goods_E007_message: "",
    PL_Pack_Main_E001_name: "",
    PL_Pack_Main_E001_message: "",
    PL_Pack_Main_E002_name: "",
    PL_Pack_Main_E002_message: "",
    PL_Pack_Main_E003_name: "",
    PL_Pack_Main_E003_message: "",
    PL_Pack_Main_E004_name: "",
    PL_Pack_Main_E004_message: "",
    AP_Goods_W002_name: "",
    AP_Goods_W002_message: "",
    AP_Goods_W003_name: "",
    AP_Goods_W003_message: "",
    AP_Goods_W004_name: "",
    AP_Goods_W004_message: "",
    AP_Goods_W005_name: "",
    AP_Goods_W005_message: "",
    CMR_Main_W001_name: "",
    CMR_Main_W001_message: "",
    CMR_Main_W002_name: "",
    CMR_Main_W002_message: "",
    CMR_Goods_E001_name: "",
    CMR_Goods_E001_message: "",
    CMR_Goods_E002_name: "",
    CMR_Goods_E002_message: "",
    CMR_Main_W003_name: "",
    CMR_Main_W003_message: "",
    CMR_Main_W004_name: "",
    CMR_Main_W004_message: "",
    validate_fix_button: "",
  },
  homepage: {
    eurasia: "",
    crossborder_link: "",
    menu_main: "首页",
    menu_about_us: "关于我们",
    menu_services: "服务",
    menu_news: "新闻",
    // menu_our_team: '联系我们',
    menu_contacts: "联系我们",
    personal_area_btn: "个人专区",
    attis_full_name: "跨境贸易自动综合结算系统（ 阿蒂斯 ）",
    attis_description:
      "以 一站式”为原则，向所有对外经济活动参与者提供全方位信息服务的国际数字平台",
    watch_video: "观看视频",
    section_our_partners: "我们的合作伙伴",
    services_and_prices: "服务与价目表",
    customer_categories: "我们的客户",
    customer_categories_description:
      "该系统将对外经济活动的所有参与者，包括边境两侧的国家和海关当局联合起来",
    attis_features: "《ATTIS 》信息系统功能",
    read_more: "阅读更多",
    show_more: "显示更多",
    show_less: "显示较少",
    section_about_us: "关于我们",
    about_us_p1:
      "哈萨克斯坦ATTIS 项目于2020 年3 月开始实施，当时代表哈萨克斯坦共和国总理成立 了一个跨部门工作组，其工作由哈萨克斯坦共和国贸易和一体化部协调。ATTIS 项目 基于先进的IT 技术，提供有效适应公共和私人信息系统，以及保证项目的快速实施。",
    about_us_p2:
      "ATTIS 项目的结构由位于欧洲、中国和哈萨克斯坦共和国的ATTIS 区域中心组成。每 个ATIS 区域中心都有其经营所在国家的认证。",
    about_us_p3:
      "ATTIS 项目的参与者和所有者均效力于《CrossborderXP(CBXP)有限责任公司(LTD)》，其总部位于都柏林（爱尔兰）。《CrossborderXP, LTD 》(CBXP) 在金融、物流、 海关程序和业务管理方面拥有丰富的经验。作为 ATTIS 的所有者《CrossborderXP,  LTD 》(CBXP)负责项目的开发和全球实施。",
    about_us_p4:
      '作为"一带一路"项目的一部分，ATTIS 项目得到了中华人民共和国政府（中华人民共 和国商务部）的行政支持与资助，并与合伙国家  启动 ATTIS 项目的开发和试点实施。 ATTIS 系统与中国的exportimport.com 系统相集成。该系统是中国进出口商的全球数 据库，目前覆盖超过100 万家中国公司。这种整合使外国经济活动的参与者有机会选 择合适价格和质量的发盘且能够直接在ATTIS 系统中完成交易。',
    about_us_p5:
      "ATTIS 项目的任务是建立一个全球且有竞争力的平台。该平台在一个信息空间内将边 境  两侧所有的外国经济活动参与者连接起来， 以《一站式》的原则提供全面的信息和 其他服务。",
    about_us_list_title: "ATTIS 项目的优势：",
    about_us_list_i1: "为所有参与者保证对外经济活动信息的透明度、效率和可用性;",
    about_us_list_i2: "贸易便利化和提高国际评级;",
    about_us_list_i3: "提高对外经济交易的透明度和可靠性;",
    about_us_list_i4: "为对外经济活动参与者简化向政府机构提交信息的程序;",
    about_us_list_i5: "减少对外经济活动参与者的时间和财务成本;",
    about_us_list_i6:
      "向对外经济活动参与者提供寻找在可信赖的信息来源中的外国交易对象和合作 伙伴的机会，并使用国际系统 ComplyAdvantage 检查其可靠性。",
    about_us_p6:
      "ATTIS 项目的目标受众包括出口商、进口商、运输和物流公司、报关行、商业银行、 保险机构、政府机构、原产地认证授权机构以及其他对外经济活动的参与者。",
    our_team_section: "",
    our_team_description: "开发和创建国际集团ATTIS 的团队领导是：",
    leader_edward: "爱德华·鲍文（EDWARD BOWEN）",
    leader_edward_job_title: "总裁",
    leader_edward_description:
      "爱德华  曾在英国陆军服役 20 多年，他在那里积累了许多    规划和组织方面的知识。 自 1994 年离开部队以来，他在拉脱维亚建立了从美国和厄瓜多尔到邻国乃至哈萨克斯坦的新鲜和冷冻食品物流公司。在出售这些公司后，他与主要的国际合作伙伴在拉脱维亚开发了多个工业园区。其中包括靠近俄罗斯边境雷泽克内自由经济区最大的私有园“ ”  区，仍然是进一步发展 一带一路 沿线陆路路线的重点。爱德华是 1997 年拉脱维亚英 国商会的首任主席，也是拉脱维亚外国投资者委员会的创始人。他与谢尔盖一起工作 了十多年，这促使了跨境业务系统CrossborderXP 创建。",
    leader_michael: "迈克尔·伯克（MICHAEL J BOURKE）",
    leader_michael_job_title: "合作伙伴。 银行与金融",
    leader_michael_description:
      "迈克尔在银行行业有超过40 年的经验。在他职业生涯的早期，在完成爱尔兰中央银行 的多项任务后，他被指派到  乌干达和埃及，为国际货币基金组织工作。然后在 1992 年 至 1997 年EU-EC Phare  计划的 5 年，担任拉脱维亚中央银行的顾问。1997   年至 2006  年，他担任Rietumu 银行（拉脱维亚）的首席执行官兼总裁。2009 年，拉脱维亚政府 与欧洲复兴开发银行要求他帮助重振Parex 银行。他担任该银行的董事长直至2017 年， 并挽回了  超过 70% 的资金损失。迈克尔拥有丰富的国际经验，曾在新斯科舍银行（爱 尔兰）和道富银行爱尔兰担任独立董事。迈克尔于1998-2006 年担任爱尔兰驻拉脱维 亚名誉领事。他是CROSSBORDERXP 的创始人之一。",
    leader_sergey: "谢尔盖·尼古拉耶夫（SERGEI NIKOLAYEV）",
    leader_sergey_job_title: "系统架构师",
    leader_sergey_description:
      "在软件开发技术和系统实施方面拥有7  项正式注册的知识产权。 拥有大约25 项电子 政务、电子银行、电子海关项目的开发、实施和支持经验。 高级专家，在其所有项目 实施的不同国家（哈萨克斯坦、俄罗斯、美国、立陶宛、白俄罗斯、乌克兰和中国 等）担任项目负责人和首席执行官超过 25 年。",
    leader_aben: "阿本·别克塔索夫（ABEN BEKTASOV）",
    leader_aben_job_title: "管理合伙人。 中亚",
    leader_aben_description:
      "30 多年来，他在哈萨克斯坦的各种政府机构和组织（国家银行、财政部、证券全国委 员会、哈萨克斯坦电信、国家 IT 和电信机构、国家安全委员会）担任高级管理领导。 作为哈萨克斯坦国家银行的副主席，他负责银行间清算系统的开发、支付系统的开发 以及养老金改革的实施。 在他的努力下，国家银行间清算系统和养老金系统被世界银 行认为是后苏联最有效的系统。",
    leader_erzhan: "叶尔展·托卡巴亚诺夫（YERZHAN TOKTABAYANOV）",
    leader_erzhan_job_title: "《ATTIS 欧亚大陆》有限责任合伙(LLP)总监",
    leader_erzhan_description:
      "叶尔展在银行和保险领域拥有超过 17 年的经验，曾在法律服务、合规控制和财务监控 部门担任高级职务。这些职位的主要任务是为银行的活动提供法律支持，包括控制银 行对反洗钱和反恐融资立法的遵守情况，在哈萨克斯坦共和国国家银行担任银行代表， “ ”哈萨克斯坦金融家协会 和其他国家机构。他是国际金融公司和世界银行的公司治理 顾问。在这项活动框架中，他参加了在塔吉克斯坦共和国主要金融组织实施公司管理 系统的项目。",
    contacts: "联系方式",
    headquarters: "总部地址",
    address: "努尔苏丹 埃希尔区 丁穆罕默德科纳耶夫街 4 号楼",
    name: "您的姓名",
    email: "电子邮箱",
    email_: "电子邮箱",
    phone: "电话",
    subject: "主题",
    message: "正文",
    send: "发送",
    gotoaccount: "转到个人帐户",
    gotoaccount_text: "立即注册ATTIS 系统",
    nursultan: "努尔苏丹",
    yesil: "埃希尔区",
    street: "丁穆罕默德科纳耶夫街",
    building: " 4 号楼",
  },
  comply_advantage: {
    search_tab: "搜索",
    case_management_tab: "案例管理",
    name_details: "名称和详细信息",
    details_name: "姓名",
    details_reference: "客户参考",
    details_birth_year: "出生年份",
    details_country: "国家",
    entity_type_title: "实体类型",
    entity_type_all: "全部",
    entity_type_person: "人",
    entity_type_company: "公司",
    entity_type_organisation: "组织",
    entity_type_vessel: "血管",
    entity_type_aircraft: "飞机",
    fuzzy_exact: "完全符合",
    fuzziness_title: "模糊",
    fuzzy_0: "0%",
    fuzzy_10: "10%",
    fuzzy_20: "20%",
    fuzzy_30: "30%",
    fuzzy_40: "40%",
    fuzzy_50: "50%",
    fuzzy_60: "60%",
    fuzzy_70: "70%",
    fuzzy_80: "80%",
    fuzzy_90: "90%",
    fuzzy_100: "100%",
    filter_date_from: "创建自",
    filter_date_to: "创建于",
    filter_name: "搜索名称",
    filter_reference: "搜索参考",
    filter_match: "比赛状态",
    filter_risk: "风险等级",
    filter_assigned_to: "分配给",
    filter_searched_by: "搜索者",
    filter_changed: "变了",
    filter_monitored: "监控",
    filter_matched: "匹配类型",
    filter_match_all: "全部",
    filter_match_unknown: "未知",
    filter_match_no: "不匹配",
    filter_match_potential: "潜在匹配",
    filter_match_false_positive: "假阳性",
    filter_match_true_positive: "真正的积极",
    filter_match_true_positive_approve: "真正的肯定 - 批准",
    filter_match_true_positive_reject: "真正的肯定 - 拒绝",
    filter_risk_all: "全部",
    filter_risk_unknown: "未知",
    filter_risk_low: "低的",
    filter_risk_medium: "中等的",
    filter_risk_high: "高的",
    filter_changed_all: "全部",
    filter_changed_changed: "变了",
    filter_changed_unchanged: "不变",
    filter_monitored_all: "全部",
    filter_monitored_actively: "主动监控",
    filter_monitored_suspended: "暂停",
    filter_monitored_unmonitored: "不受监控",
    filter_matched_types_all: "全部",
    filter_matched_types_sanctions: "制裁",
    filter_matched_types_warnings: "警告",
    filter_matched_types_fitness_probity: "健身与正直",
    filter_matched_types_peps_all: "PEP",
    filter_matched_types_pep_1: "PEP 1 级",
    filter_matched_types_pep_2: "PEP 2 级",
    filter_matched_types_pep_3: "PEP 3 级",
    filter_matched_types_pep_4: "PEP 4 级",
    filter_matched_types_adverse_media: "不良媒体",
    filter_matched_types_financial_crime: "金融犯罪",
    filter_matched_types_violent_crime: "暴力犯罪",
    filter_matched_types_sexual_crime: "性犯罪",
    filter_matched_types_terrorism: "恐怖主义",
    filter_matched_types_fraud: "欺诈罪",
    filter_matched_types_narcotics: "毒品",
    filter_matched_types_other: "其他罪行",
    table_created: "创造",
    table_names: "名称",
    table_ref: "参考",
    table_match_status: "比赛状态",
    table_risk_level: "风险等级",
    table_assigned_to: "分配给",
    table_searcher: "搜索者",
    table_changed: "变了",
    table_monitor: "监视器",
    apply_filters: "应用过滤器",
    remove_filters: "删除过滤器",
    matched_label: "匹配",
    relevance_label: "关联",
    countries_label: "国家",
    dob_label: "出生日期",
    response_entity_type_organisation: "组织",
    response_entity_type_person: "人",
    response_entity_type_company: "公司",
    response_entity_type_vessel: "血管",
    response_entity_type_aircraft: "飞机",
    response_match_sanction: "制裁",
    response_match_warning: "警告",
    response_match_pep: "PEP",
    "response_match_pep-class-1": "PEP 1 级",
    "response_match_pep-class-2": "PEP 2 级",
    "response_match_pep-class-3": "PEP 3 级",
    "response_match_pep-class-4": "PEP 4 级",
    "response_match_fitness-probity": "健身与正直",
    "response_match_adverse-media": "不良媒体",
    "response_match_adverse-media-financial-crime": "金融犯罪",
    "response_match_adverse-media-violent-crime": "暴力犯罪",
    "response_match_adverse-media-sexual-crime": "性犯罪",
    "response_match_adverse-media-terrorism": "恐怖主义",
    "response_match_adverse-media-fraud": "欺诈罪",
    "response_match_adverse-media-narcotics": "毒品",
    "response_match_adverse-media-general": "其他罪行",
    response_relevance_name_exact: "名称完全匹配",
    response_relevance_aka_exact: "Aka 完全匹配",
    response_relevance_name_fuzzy: "名称匹配紧密",
    response_relevance_aka_fuzzy: "阿卡紧密匹配",
    response_relevance_phonetic_name: "名字与拼音匹配",
    response_relevance_phonetic_aka: "Aka 拼音",
    response_relevance_equivalent_name: "名称与同义词匹配",
    response_relevance_equivalent_aka: "Aka 与同义词匹配",
    response_relevance_unknown: "复杂匹配",
    response_relevance_year_of_birth: "出生年份匹配",
    response_relevance_removed_personal_title: "删除个人头衔",
    response_relevance_removed_personal_suffix: "删除了个人后缀",
    response_relevance_removed_organisation_prefix: "删除组织前缀",
    response_relevance_removed_organisation_suffix: "删除组织后缀",
    response_relevance_removed_clerical_mark: "删除文书标记",
    case_deleted_successfully: "案例删除成功",
    case_delete_unsuccessful: "删除案例时出错",
  },
  contragent_search: {
    date: "Date",
    search_text: "Search request",
    service_code: "Service name",
    do_bulk: "Bulk request",
    annual_report: "年度报告",
    annual_report_no_logo: "年度报告（无标志）",
    enterprise_risk_scan: "企业风险扫描",
    enterprise_risk_scan_no_logo: "企业风险扫描（无标志）",
    AssetsData: "Assets Data",
    SocialInsurance: "Social Insurance",
    BasicInfo: "Basic Info",
    ChangeList: "Change List",
    InvestInfoList: "Invest Info List",
    PartnerList: "Partner List",
    ProvideAssuranceList: "Provide Assurance List",
    StockChangeList: "Stock Change List",
    WebSiteList: "Web Site List",
    AdministrationLicenseList: "Administration License List",
    BranchList: "Branch List",
    EmployeeList: "Employee List",
    No: "No",
    Year: "Year",
    PublishDate: "Publish Date",
    TotalAssets: "Total Assets",
    TotalOwnersEquity: "Total Owners Equity",
    GrossTradingIncome: "Gross Trading Income",
    MainBusinessIncome: "Main Business Income",
    NetProfit: "Net Profit",
    TotalTaxAmount: "Total Tax Amount",
    TotalLiabilities: "Total Liabilities",
    BankingCredit: "Banking Credit",
    GovernmentSubsidy: "Government Subsidy",
    UrbanBasicIns: "Urban Basic Ins",
    EmployeeBasicIns: "Employee Basic Ins",
    MaternityIns: "Maternity Ins",
    UnemploymentIns: "Unemployment Ins",
    IndustrialInjuryIns: "Industrial Injury Ins",
    EntUrbanBasicInsNum: "Ent Urban Basic Ins Num",
    EntUnemploymentInsNum: "Ent Unemployment Ins Num",
    EntEmployeeBasicInsNum: "Ent Employee Basic Ins Num",
    EntIndustrialInjuryInsNum: "Ent Industrial Injury Ins Num",
    EntMaternityInsNum: "Ent Maternity Ins Num",
    ActUrbanBasicInsAmount: "Act Urban Basic Ins Amount",
    ActUnemploymentInsAmount: "Act Unemployment Ins Amount",
    ActEmployeeBasicInsAmount: "Act Employee Basic Ins Amount",
    ActIndustrialInjuryInsAmount: "Act Industrial Injury Ins Amount",
    ActMaternityInsAmount: "Act Maternity Ins Amount",
    OweUrbanBasicInsAmount: "Owe Urban Basic Ins Amount",
    OweUnemploymentInsAmount: "Owe Unemployment Ins Amount",
    OweIndustrialInjuryInsAmount: "Owe Industrial Injury Ins Amount",
    OweMaternityInsAmount: "Owe Maternity Ins Amount",
    RegNo: "Reg No",
    CompanyName: "Company  Name",
    CreditCode: "Credit Code",
    OperatorName: "Operator Name",
    ContactNo: "Contact No",
    PostCode: "Post Code",
    Address: "Address",
    EmailAddress: "Email Address",
    IsStockRightTransfer: "Is Stock Right Transfer",
    Status: "Status",
    HasWebSite: "Has Web Site",
    HasNewStockOrByStock: "Has New Stock Or By Stock",
    EmployeeCount: "Employee Count",
    BelongTo: "Belong To",
    CapitalAmount: "Capital Amount",
    HasProvideAssurance: "Has Provide Assurance",
    OperationPlaces: "Operation Places",
    MainType: "Main Type",
    OperationDuration: "Operation Duration",
    IfContentSame: "If Content Same",
    DifferentContent: "Different Content",
    GeneralOperationItem: "General Operation Item",
    ApprovedOperationItem: "Approved Operation Item",
    No: "No",
    ChangeName: "Change Name",
    Before: "Before",
    After: "After",
    ChangeDate: "Change Date",
    Name: "Name",
    ShouldCapi: "Should Capi",
    ShouldDate: "Should Date",
    ShouldType: "Should Type",
    RealCapi: "Real Capi",
    RealDate: "Real Date",
    RealType: "Real Type",
    Form: "Form",
    InvestmentRatio: "Investment Ratio",
    KeyNo: "Key No",
    ShareholdingRatio: "Shareholding Ratio",
    Creditor: "Creditor",
    Debtor: "Debtor",
    CreditorCategory: "Creditor Category",
    CreditorAmount: "Creditor Amount",
    FulfillObligation: "Fulfill Obligation",
    AssuranceDurn: "Assurance Durn",
    AssuranceType: "Assurance Type",
    AssuranceScope: "Assurance Scope",
    Type: "Type",
    WebSite: "Web Site",
    EndDate: "End Date",
    principal: "principal",
    Job: "Job",
    CerNo: "Cer No",
    ScertName: "Scert Name",
    ers_AreaCode: "Area Code",
    ers_RecCap: "Rec Cap",
    ers_EntType: "Ent Type",
    ers_ImageUrl: "Image Url",
    ers_StockType: "Stock Type",
    ers_StockNumber: "Stock Number",
    ers_IsOnStock: "Is On Stock",
    ers_OrgNo: "Org No",
    ers_CheckDate: "Check Date",
    ers_TeamEnd: "Team End",
    ers_TermStart: "Term Start",
    ers_Scope: "Scope",
    ers_Address: "Address",
    ers_EconKind: "Econ Kind",
    ers_RegistCapi: "Regist Capi",
    ers_CreditCode: "Credit Code",
    ers_UpdatedDate: "Updated Date",
    ers_Province: "Province",
    ers_Status: "Status",
    ers_EndDate: "End Date",
    ers_StartDate: "Start Date",
    ers_OperName: "Oper Name",
    ers_OperId: "Oper Id",
    ers_BelongOrg: "Belong Org",
    ers_No: "No",
    ers_Name: "Name",
    ers_KeyNo: "Key No",
    ers_IXCode: "I X Code",
    ers_PersonScope: "Person Scope",
    ers_EnglishName: "English Name",
    ers_InsuredCount: "Insured Count",
    ers_pi_Name: "Name",
    ers_pi_Province: "Province",
    ers_pi_Liandate: "Liandate",
    ers_pi_CaseNo: "Case No",
    ers_pi_DocNo: "Doc No",
    ers_pi_PenaltyType: "Penalty Type",
    ers_pi_OfficeName: "Office Name",
    ers_pi_Content: "Content",
    ers_pi_PenaltyDate: "Penalty Date",
    ers_pi_PublicDate: "Public Date",
    ers_pi_Remark: "Remark",
    ers_pi_AddReason: "Add Reason",
    ers_pi_AddDate: "Add Date",
    ers_pi_RomoveReason: "Romove Reason",
    ers_pi_RemoveDate: "Remove Date",
    ers_pi_DecisionOffice: "Decision Office",
    ers_pi_RemoveDecisionOffice: "Remove Decision Office",
    ers_pi_Anno: "Anno",
    ers_pi_Orgno: "Orgno",
    ers_pi_Execute: "Execute",
    ers_pi_Publicdate: "Publicdate",
    ers_pi_Executestatus: "Executestatus",
    ers_pi_Actionremark: "Actionremark",
    ers_pi_Executegov: "Executegov",
    ers_pi_Id: "Id",
    ers_pi_Sourceid: "Sourceid",
    ers_pi_ExecuteGov: "Execute Gov",
    ers_pi_Biaodi: "Biaodi",
    ers_pi_Status: "Status",
    ers_pi_PartyCardNum: "Party Card Num",
    ers_pi_Updatedate: "Updatedate",
    ers_pi_RegisterNo: "Register No",
    ers_pi_RegisterDate: "Register Date",
    ers_pi_RegisterOffice: "Register Office",
    ers_pi_DebtSecuredAmount: "Debt Secured Amount",
    ers_pi_Leader: "Leader",
    ers_pi_Member: "Member",
    ers_pi_CompanyId: "Company Id",
    ers_pi_RegistNo: "Regist No",
    ers_pi_Pledgor: "Pledgor",
    ers_pi_PledgorNo: "Pledgor No",
    ers_pi_Pledge: "Pledge",
    ers_pi_PledgeNo: "Pledge No",
    ers_pi_PledgedAmount: "Pledged Amount",
    ers_pi_RegDate: "Reg Date",
    ers_pi_No: "No",
    ers_pi_ExecutiveOrg: "Executive Org",
    ers_pi_Type: "Type",
    ers_pi_Date: "Date",
    ers_pi_Consequence: "Consequence",
    ers_pi_Year: "Year",
    ers_pi_Level: "Level",
    ers_pi_CompanyName: "Company Name",
    ers_pi_Link: "Link",
    ers_pi_ImageUrl: "Image Url",
    ers_pi_Domain: "Domain",
    ers_pi_Tags: "Tags",
    ers_pi_Description: "Description",
    ers_pi_Category: "Category",
    ers_pi_LicensesDocNo: "Licenses Doc No",
    ers_pi_LicensesDocName: "Licenses Doc Name",
    ers_pi_ValidityFrom: "Validity From",
    ers_pi_ValidityTo: "Validity To",
    ers_pi_LicensOffice: "Licens Office",
    ers_pi_LicensesContent: "Licenses Content",
    ers_pi_OwnerName: "Owner Name",
    ers_pi_CaseReason: "Case Reason",
    ers_pi_KeyNo: "Key No",
    ers_pi_StockName: "Stock Name",
    ers_pi_StockType: "Stock Type",
    ers_pi_StockPercent: "Stock Percent",
    ers_pi_ShouldCapi: "Should Capi",
    ers_pi_ShouldDate: "Should Date",
    ers_pi_InvestType: "Invest Type",
    ers_pi_InvestName: "Invest Name",
    ers_pi_RealCapi: "Real Capi",
    ers_pi_CapiDate: "Capi Date",
    ers_pi_TagsList: "Tags List",
    ers_pi_FinalBenefitPercent: "Final Benefit Percent",
    ers_pi_RelatedProduct: "Related Product",
    ers_pi_RelatedOrg: "Related Org",
    ers_pi_Job: "Job",
    ers_pi_RegNo: "Reg No",
    ers_pi_BelongOrg: "Belong Org",
    ers_pi_CreditCode: "Credit Code",
    ers_pi_OperName: "Oper Name",
    ers_pi_ProjectName: "Project Name",
    ers_pi_BeforeContent: "Before Content",
    ers_pi_AfterContent: "After Content",
    ers_pi_ChangeDate: "Change Date",
    ers_pi_name: "name",
    ers_pi_WebSite: "Web Site",
    ers_pi_PhoneNumber: "Phone Number",
    ers_pi_Email: "Email",
    ers_pi_IndustryCode: "Industry Code",
    ers_pi_Industry: "Industry",
    ers_pi_SubIndustryCode: "Sub Industry Code",
    ers_pi_SubIndustry: "Sub Industry",
    ers_pi_MiddleCategoryCode: "Middle Category Code",
    ers_pi_MiddleCategory: "Middle Category",
    ers_pi_SmallCategoryCode: "Small Category Code",
    ers_pi_SmallCategory: "Small Category",
    ers_pi_ContactNo: "Contact No",
    ers_pi_EmailAddress: "Email Address",
    ers_pi_Address: "Address",
    ers_Liquidation: "Liquidation",
    ers_ContactInfo: "Contact Info",
    ers_Industry: "Industry",
    ers_Area: "Area",
    ers_area_Province: "Province",
    ers_area_City: "City",
    ers_area_County: "County",
    ers_rev_CancelDate: "Cancel Date",
    ers_rev_CancelReason: "Cancel Reason",
    ers_rev_RevokeDate: "Revoke Date",
    ers_rev_RevokeReason: "Revoke Reason",
    ers_RevokeInfo: "Revoke Info",
    ers_ind_IndustryCode: "Industry Code",
    ers_ind_Industry: "Industry",
    ers_ind_SubIndustryCode: "Sub Industry Code",
    ers_ind_SubIndustry: "Sub Industry",
    ers_ind_MiddleCategoryCode: "Middle Category Code",
    ers_ind_MiddleCategory: "Middle Category",
    ers_ind_SmallCategoryCode: "Small Category Code",
    ers_ind_SmallCategory: "Small Category",
    ers_PermissionInfo: "Permission Info",
    ers_Penalty: "Penalty",
    ers_Exceptions: "Exceptions",
    ers_ShiXinItems: "Shi Xin Items",
    ers_ZhiXingItems: "Zhi Xing Items",
    ers_MPledge: "M Pledge",
    ers_Pledge: "Pledge",
    ers_SpotCheck: "Spot Check",
    ers_CompanyTaxCreditItems: "Company Tax Credit Items",
    ers_CompanyProducts: "Company Products",
    ers_PermissionEciInfo: "Permission Eci Info",
    ers_PenaltyCreditChina: "Penalty Credit China",
    ers_Partners: "Partners",
    ers_Employees: "Employees",
    ers_Branches: "Branches",
    ers_ChangeRecords: "Change Records",
    ers_EmergingIndustyList: "Emerging Industy List",
    ers_TagList: "Tag List",
    ers_ARContactList: "A R Contact List",
    ers_OriginalName: "Original Name",
    TotalProfit: "Total profit",
  },
};
